(function () {
  'use strict';

  // =========================
  // Global configuration / selectors
  // =========================
  const SECTION_ID = 'customMealBuilderLeadingSection';
  const WEEK_BTN_SEL = '.meal-builder-main__week-selector-option';
  const DIET_GROUPSEL = '.meal-builder-main__plan-selector-options.first-mode';
  const DAYS_GROUPSEL = '.meal-builder-main__plan-selector-options.second-mode';
  const PLAN_BTN_SEL = '.meal-builder-main__plan-selector-option';
  const GROUPINGS_SEL = '.meal-builder-main__groupings';

  const WEEK_MAP = { 'week-a-menu': 'A', 'week-b-menu': 'B' };
  const DAYS_MAP = { '3-day-plan': 3, '5-day-plan': 5, '7-day-plan': 7 };
  const DIET_MAP = { 'all-meals': 'all-meals', 'plant-meals-only': 'plant-meals-only' };

  const CHANGE_PREFIX = 'Switch Up ';
  const infoTooltipIconUrl =
    (window.customMealBuilderIcons && window.customMealBuilderIcons.meal_card_info_svg) ||
    'https://cdn.shopify.com/s/files/1/2958/7314/files/meal-card-info.svg?v=1764763726';

  // Debug helpers (toggle with window.__MB_DEBUG__ = true)
  const DEBUG = !!window.__MB_DEBUG__;
  const log = (...a) => DEBUG && console.log('[MealBuilder]', ...a);
  const warn = (...a) => console.warn('[MealBuilder]', ...a);

  // Swiper arrows SVGs
  const ARROW_PREV = `
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.245703 9.58964L7.7457 17.0896C7.90207 17.246 8.11415 17.3339 8.33529 17.3339C8.55642 17.3339 8.7685 17.246 8.92487 17.0896C9.08124 16.9333 9.16908 16.7212 9.16908 16.5001C9.16908 16.2789 9.08124 16.0668 8.92487 15.9105L2.84674 9.83339H19.1686C19.3896 9.83339 19.6016 9.74559 19.7579 9.58931C19.9142 9.43303 20.002 9.22107 20.002 9.00006C20.002 8.77904 19.9142 8.56708 19.7579 8.4108C19.6016 8.25452 19.3896 8.16672 19.1686 8.16672H2.84674L8.92487 2.08964C9.08124 1.93327 9.16908 1.72119 9.16908 1.50006C9.16908 1.27892 9.08124 1.06684 8.92487 0.910473C8.7685 0.754106 8.55642 0.66626 8.33529 0.66626C8.11415 0.66626 7.90207 0.754106 7.7457 0.910473L0.245703 8.41047C0.168222 8.48787 0.106756 8.57977 0.0648193 8.68094C0.0228825 8.7821 0.0012989 8.89054 0.0012989 9.00006C0.0012989 9.10957 0.0228825 9.21801 0.0648193 9.31917C0.106756 9.42034 0.168222 9.51225 0.245703 9.58964Z" fill="#36533E"></path>
    </svg>`;
  const ARROW_NEXT = `
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7543 9.58964L12.2543 17.0896C12.0979 17.246 11.8858 17.3339 11.6647 17.3339C11.4436 17.3339 11.2315 17.246 11.0751 17.0896C10.9188 16.9333 10.8309 16.7212 10.8309 16.5001C10.8309 16.2789 10.9188 16.0668 11.0751 15.9105L17.1533 9.83339H0.83138C0.610366 9.83339 0.398405 9.74559 0.242125 9.58931C0.0858444 9.43303 -0.00195312 9.22107 -0.00195312 9.00006C-0.00195312 8.77904 0.0858444 8.56708 0.242125 8.4108C0.398405 8.25452 0.610366 8.16672 0.83138 8.16672H17.1533L11.0751 2.08964C10.9188 1.93327 10.8309 1.72119 10.8309 1.50006C10.8309 1.27892 10.9188 1.06684 11.0751 0.910473C11.2315 0.754106 11.4436 0.66626 11.6647 0.66626C11.8858 0.66626 12.0979 0.754106 12.2543 0.910473L19.7543 8.41047C19.8318 8.48787 19.8932 8.57977 19.9352 8.68094C19.9771 8.7821 19.9987 8.89054 19.9987 9.00006C19.9987 9.10957 19.9771 9.21801 19.9352 9.31917C19.8932 9.42034 19.8318 9.51225 19.7543 9.58964Z" fill="#36533E"></path>
    </svg>`;

  // ============================
  // Shared helpers (single source of truth)
  // ============================
  function esc(v) {
    // Simple HTML escape for safe insertion
    return v == null
      ? ''
      : String(v)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
  }

  // Coerce numeric-like to integer; fallback if NaN/empty
  function toInt(v, fallback = 0) {
    if (v === 0) return 0;
    if (v == null || v === '') return fallback;
    const n = Number.parseInt(String(v).trim(), 10);
    return Number.isNaN(n) ? fallback : n;
  }

  // Coerce numeric-like to float; fallback if NaN/empty
  function toNum(v, fallback = null) {
    if (v === 0) return 0;
    if (v == null || v === '') return fallback;
    const n = Number(String(v).trim());
    return Number.isNaN(n) ? fallback : n;
  }

  // Build safe id attribute from string
  function idify(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9\-_:.]/g, '-');
  }

  // Map first dietaryType value to icon URL
  function dietaryIconSrc(firstLabel) {
    const s = (firstLabel || '').toLowerCase();
    const icons = window.customMealBuilderIcons || {};

    if (s === 'vegan') {
      return icons.meal_builder_product_card_vegan_icon_svg || '';
    }

    if (s === 'plant based' || s === 'plant-based') {
      return icons.meal_builder_product_card_plant_icon_svg || '';
    }

    if (s === 'fish') {
      return icons.meal_builder_product_card_fish_icon_svg || '';
    }

    if (s === 'meat') {
      return icons.meal_builder_product_card_meat_icon_svg || '';
    }

    return '';
  }

  // Map first dietaryType value to tooltip content
  function dietaryTooltipContent(firstLabel) {
    const s = (firstLabel || '').toLowerCase();
    if (s === 'vegan') return '100% plant based, no animal products';
    if (s === 'plant based' || s === 'plant-based')
      return 'Made from plants, may include dairy/eggs';
    if (s === 'fish') return 'Contains fish';
    if (s === 'meat') return 'Contains meat';
    return '';
  }

  // Show/hide small helpers
  function showEl(el) {
    if (el) {
      el.hidden = false;
      el.style.display = '';
    }
  }
  function hideEl(el) {
    if (el) {
      el.hidden = true;
      el.style.display = 'none';
    }
  }

  // Set text content into container (optionally into inner selector) or hide container
  function setTextOrHide(containerEl, innerSel, value) {
    if (!containerEl) return;
    const target = innerSel ? containerEl.querySelector(innerSel) : containerEl;
    const has = value != null && String(value).trim() !== '';
    if (!target) return;
    if (has) {
      target.textContent = String(value);
      showEl(containerEl);
    } else {
      hideEl(containerEl);
    }
  }

  // Set HTML into element or hide it
  function setHTMLOrHide(containerEl, html) {
    if (!containerEl) return;
    const has = html != null && String(html).trim() !== '';
    if (has) {
      containerEl.innerHTML = html;
      showEl(containerEl);
    } else {
      hideEl(containerEl);
    }
  }

  // Converts Shopify Rich Text JSON (or stringified JSON) into HTML
  function richTextToHTML(input) {
    // Empty → empty string
    if (!input) return '';

    // Already HTML → return as-is
    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (trimmed.startsWith('<')) return trimmed;
      // Try to parse JSON string
      try {
        input = JSON.parse(input);
      } catch {
        // Fallback: wrap raw text into <p>
        return `<p>${esc(input)}</p>`;
      }
    }

    // Recursive walker over Shopify rich text nodes
    const walk = node => {
      if (!node) return '';
      switch (node.type) {
        case 'root':
          return (node.children || []).map(walk).join('');
        case 'paragraph':
          return `<p>${(node.children || []).map(walk).join('')}</p>`;
        case 'text': {
          let out = esc(node.value || '');
          if (node.bold) out = `<strong>${out}</strong>`;
          if (node.italic) out = `<em>${out}</em>`;
          if (node.underline) out = `<u>${out}</u>`;
          if (node.strikethrough) out = `<s>${out}</s>`;
          if (node.code) out = `<code>${out}</code>`;
          return out;
        }
        case 'link': {
          const url = esc(node.url || node.href || '#');
          const target = node.target ? ` target="${esc(node.target)}"` : '';
          return `<a href="${url}" rel="noopener noreferrer"${target}>${(node.children || []).map(walk).join('')}</a>`;
        }
        case 'list':
        case 'bulleted_list':
        case 'numbered_list': {
          const ordered =
            node.type === 'list' ? node.listType === 'ordered' : node.type === 'numbered_list';
          const tag = ordered ? 'ol' : 'ul';
          const li = (node.children || []).map(walk).join('');
          return `<${tag}>${li}</${tag}>`;
        }
        case 'list-item':
        case 'list_item':
          return `<li>${(node.children || []).map(walk).join('')}</li>`;
        case 'heading': {
          const level = Math.min(6, Math.max(1, node.level || 2));
          return `<h${level}>${(node.children || []).map(walk).join('')}</h${level}>`;
        }
        case 'hardbreak':
          return '<br>';
        default:
          return (node.children || []).map(walk).join('');
      }
    };

    return walk(input);
  }

  function pulseGroupingsLoading(duration = 200) {
    const section = document.getElementById(SECTION_ID);
    const container = section?.querySelector(GROUPINGS_SEL);
    if (!container) return;

    if (container._mbLoadTmr) clearTimeout(container._mbLoadTmr);

    container.classList.add('loading');
    container._mbLoadTmr = setTimeout(() => {
      container.classList.remove('loading');
      container._mbLoadTmr = null;
    }, duration);
  }

  // Prefer the parent bundle line if present; otherwise fallback to the last item
  function pickJustAddedPreferred(items) {
    if (!Array.isArray(items) || !items.length) return null;

    // Score function: prefer items having preset/bundle props and appearing later in the array
    const score = (it, idx) => {
      const p = it?.properties || {};
      let s = 0;
      if (p._preset_id) s += 4;
      if (p._rb_id) s += 3;
      if (p.bundle || p._bundle) s += 2;

      s += idx / 1000;
      return s;
    };

    let best = items[0];
    let bestScore = score(best, 0);

    for (let i = 1; i < items.length; i++) {
      const sc = score(items[i], i);
      if (sc >= bestScore) {
        best = items[i];
        bestScore = sc;
      }
    }

    return best || items[items.length - 1];
  }

  // Fetch the live cart snapshot from Shopify
  async function getCartSnapshot() {
    // Use cache buster to avoid stale responses in some browsers
    const res = await fetch(`/cart.js?t=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return res.ok ? await res.json().catch(() => null) : null;
  }

  // Try to find a matching line_item in cart.js for enrichment
  function findMatchingCartItem(cart, seed) {
    if (!cart || !Array.isArray(cart.items) || !seed) return null;

    // 1) Strict match by "key" (most reliable)
    if (seed.key) {
      const hit = cart.items.find(li => li.key === seed.key);
      if (hit) return hit;
    }

    // 2) Match by variant_id + preset/bundle props
    const hasPreset = !!(seed.properties && (seed.properties._preset_id || seed.properties._rb_id));
    if (hasPreset) {
      const hit = [...cart.items].reverse().find(li => {
        if (li.variant_id !== seed.variant_id) return false;
        const p = li.properties || {};
        return (
          p._preset_id === seed?.properties?._preset_id || p._rb_id === seed?.properties?._rb_id
        );
      });
      if (hit) return hit;
    }

    // 3) Fallback: last item with the same variant_id (parent is usually appended last)
    const byVariant = [...cart.items].reverse().find(li => li.variant_id === seed.variant_id);
    return byVariant || cart.items[cart.items.length - 1] || null;
  }

  // Derive "handle" from URL if cart.js item lacks it
  function deriveHandleFromUrl(url) {
    try {
      const m = String(url || '').match(/\/products\/([^/?#]+)/i);
      return m ? decodeURIComponent(m[1]) : null;
    } catch {
      return null;
    }
  }

  // Merge extra fields from cart.js; keep original fields as base
  async function enrichCartItemFromCartJS(seedItem) {
    if (!seedItem) return seedItem;

    const cart = await getCartSnapshot().catch(() => null);
    const rich = findMatchingCartItem(cart, seedItem);
    if (!rich) return seedItem;

    if (!rich.handle && rich.url) {
      const h = deriveHandleFromUrl(rich.url);
      if (h) rich.handle = h;
    }

    // Return the richer object (it already contains all base fields + more)
    return rich;
  }

  // ---- Unified /cart/add response handler ----
  async function processCartAddResponse(res) {
    let json = null;
    try {
      json = await res.json();
    } catch (_) {}

    await window.MealBuilder?.Discounts?.applyAutoCodeIfAny?.();
    await refreshCartSectionsViaGET();

    let productForEvent = pickJustAddedPreferred(json?.items || []);

    try {
      productForEvent = await enrichCartItemFromCartJS(productForEvent);
    } catch (e) {
      console.warn('[MealBuilder] enrich step failed; using minimal product', e);
    }

    try {
      // Fire event with richer payload
      window.dispatchCustomEvent?.('cart:item-added', { product: productForEvent });
    } catch (_) {}

    // Turn off this popover - requested by George on 24th Feb 2026
    // window.MealBuilder?.Notice?.maybeShowIntroLoginReminder?.();
  }

  // Build a stable key for the current preset (diet + days + week)
  const presetKey = s => `${s?.diet || 'all-meals'}|${s?.days || 5}|${s?.week || 'A'}`;

  // Deep clone to keep cache snapshots isolated from live objects
  const deepClone = obj =>
    typeof structuredClone === 'function' ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));

  function getSelectedValue(container, itemSel) {
    return container?.querySelector(`${itemSel}[data-selected="true"]`)?.dataset.value || null;
  }

  function toggleSelectionInGroup(groupEl, btnEl, itemSel) {
    groupEl.querySelectorAll(itemSel).forEach(b => {
      b.setAttribute('aria-pressed', 'false');
      b.dataset.selected = 'false';
    });
    btnEl.setAttribute('aria-pressed', 'true');
    btnEl.dataset.selected = 'true';
  }

  // Format money like "£2.99" (default GBP), safe for missing/NaN amounts
  function moneySymbol(code) {
    const sym = { GBP: '£', USD: '$', EUR: '€' };
    return sym[String(code || 'GBP').toUpperCase()] || '';
  }
  function formatMoney(amount, currencyCode = 'GBP') {
    const n = Number(amount) || 0;
    return `${moneySymbol(currencyCode)}${n.toFixed(2)}`;
  }

  // =========================
  // Data bootstrap (Storefront GraphQL → window.PRESS_MEAL_PLAN)
  // =========================
  async function buildPressMealPlan() {
    const seedEl = document.getElementById('press-plan-data');
    if (!seedEl) {
      warn('[MealBuilder] press-plan-data element not found');
      window.PRESS_MEAL_PLAN = { plan: {}, groupings: {}, meals: {}, entries: {}, chefs: {} };
      return window.PRESS_MEAL_PLAN;
    }
    const seed = JSON.parse(seedEl.textContent);

    function normalizeParentRef(raw) {
      if (!raw) return { id: null, handle: null, variantId: null };
      if (typeof raw === 'string') {
        if (raw.startsWith('gid://shopify/ProductVariant/'))
          return { id: null, handle: null, variantId: raw };
        if (raw.startsWith('gid://')) return { id: raw, handle: null, variantId: null };
        return { id: null, handle: raw, variantId: null };
      }
      if (typeof raw === 'object') {
        const id = raw.id || raw.productId || null;
        const handle = raw.handle || raw.value || raw.slug || null;
        const variantId =
          raw.variantId || raw.productVariantId || raw.parentBundleVariantId || null;
        return { id, handle, variantId };
      }
      return { id: null, handle: null, variantId: null };
    }

    const parentRef = normalizeParentRef(
      seed.plan?.parentBundleProduct ??
        seed.plan?.parent_bundle_product ??
        seed.plan?.parentProduct ??
        seed.plan?.parent_product ??
        seed.parentBundleProduct ??
        seed.parent_bundle_product
    );

    const parentVariantOverride =
      seed.plan?.parentBundleVariantId ?? seed.plan?.parent_bundle_variant_id ?? null;

    log('seed.plan keys:', Object.keys(seed.plan || {}));
    log('parentRef =', parentRef, 'variantOverride =', parentVariantOverride);

    const baseIds = new Set([
      ...(seed.plan?.weeks?.A || []),
      ...(seed.plan?.weeks?.B || []),
      ...(seed.plan?.weeklyAddOns || [])
    ]);
    // Include parent product or variant up front to avoid extra network later
    if (parentRef?.variantId) baseIds.add(parentRef.variantId);
    else if (parentRef?.id) baseIds.add(parentRef.id);

    if (!baseIds.size) {
      window.PRESS_MEAL_PLAN = {
        plan: seed.plan,
        groupings: {},
        meals: {},
        entries: {},
        chefs: {}
      };
      return window.PRESS_MEAL_PLAN;
    }

    // Prefer reading token from global (injected via Liquid). Fallback to hardcoded string if needed.
    const STOREFRONT_TOKEN = window.__MB_STOREFRONT_TOKEN__ || '6c03805e19d2cd5b6cda0cc51cdbda14'; // TODO: inject via Liquid settings for security
    const GQL_ENDPOINT = '/api/2025-01/graphql.json';
    const GQL_HEADERS = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
    };

    const NODES_QUERY = `
      query NodesByIds($ids: [ID!]!) {
        nodes(ids: $ids) {
          __typename

          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              type
              value
              reference {
                __typename

                ... on Metaobject {
                  id
                  handle
                  type
                }

                ... on ProductVariant {
                  id
                  availableForSale
                  quantityAvailable
                  price { amount currencyCode }
                  image { url altText width height }
                  selectedOptions { name value }
                  product {
                    id
                    handle
                    title
                    featuredImage { url altText width height }
                    collections(first: 50) {
                      nodes { id title }
                    }
                  }
                  sellingPlanAllocations(first: 100) {
                    nodes {
                      sellingPlan { id name }
                    }
                  }
                }

                ... on MediaImage {
                  id
                  image { url altText width height }
                }

                ... on GenericFile {
                  id
                  url
                  mimeType
                }

                ... on Collection {
                  id
                  handle
                  title
                }
              }
              references(first: 200) {
                nodes {
                  __typename
                  ... on Metaobject { id handle type }
                }
              }
            }
          }

          ... on ProductVariant {
            id
            availableForSale
            quantityAvailable
            price { amount currencyCode }
            image { url altText width height }
            selectedOptions { name value }
            product {
              id
              handle
              title
              featuredImage { url altText width height }
              collections(first: 50) {
                nodes { id title }
              }
            }
            sellingPlanAllocations(first: 100) {
              nodes {
                sellingPlan { id name }
              }
            }
          }

          ... on MediaImage {
            id
            image { url altText width height }
          }

          ... on GenericFile {
            id
            url
            mimeType
          }

          ... on Product {
            id
            handle
            title
            variants(first: 50) {
              nodes {
                id
                quantityAvailable
                title
                selectedOptions { name value }
                price { amount currencyCode }
                image { url altText width height }
                sellingPlanAllocations(first: 100) {
                  nodes { sellingPlan { id name } }
                }
              }
            }
            sellingPlanGroups(first: 20) {
              nodes {
                sellingPlans(first: 100) { nodes { id name } }
              }
            }
          }
        }
      }
    `;

    const PRODUCT_BY_HANDLE_QUERY = `
          query ProductByHandle($handle: String!) {
            productByHandle(handle: $handle) {
              id
              handle
              title
              variants(first: 50) {
                nodes {
                  id
                  quantityAvailable
                  title
                  selectedOptions { name value }
                  price { amount currencyCode }
                  image { url altText width height }
                  sellingPlanAllocations(first: 100) {
                    nodes { sellingPlan { id name } }
                  }
                }
              }
              sellingPlanGroups(first: 20) {
                nodes {
                  sellingPlans(first: 100) { nodes { id name } }
                }
              }
            }
          }
        `;

    async function fetchProductByHandle(handle) {
      try {
        const res = await fetch(GQL_ENDPOINT, {
          method: 'POST',
          headers: GQL_HEADERS,
          body: JSON.stringify({ query: PRODUCT_BY_HANDLE_QUERY, variables: { handle } })
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || json.errors)
          warn('Storefront errors (productByHandle)', res.status, json.errors || json);
        const p = json.data?.productByHandle || null;
        if (!p) return null;
        p.__typename = 'Product';
        return p;
      } catch (e) {
        warn('fetchProductByHandle error', e);
        return null;
      }
    }

    const PRODUCT_BY_ID_QUERY = `
          query ProductById($id: ID!) {
            product(id: $id) {
              id handle title
              variants(first: 50) {
                nodes {
                  id
                  title
                  quantityAvailable
                  selectedOptions { name value }
                  price { amount currencyCode }
                  image { url altText width height }
                  sellingPlanAllocations(first: 100) { nodes { sellingPlan { id name } } }
                }
              }
              sellingPlanGroups(first: 20) { nodes { sellingPlans(first: 100) { nodes { id name } } } }
            }
          }
        `;
    async function fetchProductById(id) {
      try {
        const res = await fetch(GQL_ENDPOINT, {
          method: 'POST',
          headers: GQL_HEADERS,
          body: JSON.stringify({ query: PRODUCT_BY_ID_QUERY, variables: { id } })
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || json.errors)
          warn('Storefront errors (productById)', res.status, json.errors || json);
        const p = json.data?.product || null;
        if (p) p.__typename = 'Product';
        return p;
      } catch (e) {
        warn('fetchProductById error', e);
        return null;
      }
    }

    async function fetchProductByHandleViaJs(handle) {
      try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return null;
        const p = await res.json();
        const toMoney = v => {
          const n = Number(v);
          return Number.isFinite(n) ? n : 0;
        };
        return {
          __typename: 'Product',
          id: `gid://shopify/Product/${p.id}`,
          handle: p.handle,
          title: p.title,
          variants: {
            nodes: (p.variants || []).map(v => ({
              id: `gid://shopify/ProductVariant/${v.id}`,
              title: v.title,
              selectedOptions: [],
              price: { amount: toMoney(v.price ?? v.price_min ?? 0), currencyCode: 'GBP' },
              image: v.featured_image
                ? {
                    url: v.featured_image.src,
                    altText: v.featured_image.alt || null,
                    width: null,
                    height: null
                  }
                : null,
              sellingPlanAllocations: { nodes: [] },
              inventoryPolicy: null,
              inventoryQuantity: null
            }))
          },
          sellingPlanGroups: { nodes: [] }
        };
      } catch (e) {
        warn('fetchProductByHandleViaJs error', e);
        return null;
      }
    }

    // Safe fetch for nodes with error handling
    async function fetchNodes(ids) {
      if (!ids.size) return [];
      try {
        const res = await fetch(GQL_ENDPOINT, {
          method: 'POST',
          headers: GQL_HEADERS,
          body: JSON.stringify({ query: NODES_QUERY, variables: { ids: [...ids] } })
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || json.errors)
          warn('Storefront errors (nodes)', res.status, json.errors || json);
        return (json.data?.nodes || []).filter(Boolean);
      } catch (e) {
        warn('fetchNodes failed', e);
        return [];
      }
    }

    // Helpers for normalization
    const stripGid = gid => (typeof gid === 'string' ? gid.split('/').pop() : gid);
    const uniq = arr => Array.from(new Set(arr));

    function pickVariantImageOrProduct(variantNode) {
      const v = variantNode?.image;
      if (v?.url)
        return {
          url: v.url,
          altText: v.altText || null,
          width: v.width || null,
          height: v.height || null
        };
      const p = variantNode?.product?.featuredImage;
      return p?.url
        ? {
            url: p.url,
            altText: p.altText || null,
            width: p.width || null,
            height: p.height || null
          }
        : null;
    }

    function findMealBuilderCollectionId(productNode) {
      const nodes = productNode?.collections?.nodes || [];
      const hit = nodes.find(
        c =>
          typeof c.title === 'string' &&
          c.title.toLowerCase().includes('signature nutrition programme')
      );
      return hit ? stripGid(hit.id) : null;
    }

    function toStringArray(v) {
      if (v == null || v === '') return [];
      if (Array.isArray(v)) return v.map(String);
      try {
        const parsed = JSON.parse(v);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch (e) {}
      return String(v)
        .split(/[\n,]+/)
        .map(s => s.trim())
        .filter(Boolean);
    }

    // Turn Metaobject.fields[] into a plain object and normalize references
    function inflateMetaobject(node) {
      const out = { id: node.id, handle: node.handle, type: node.type, fields: {} };
      for (const f of node.fields || []) {
        if (f.references?.nodes?.length) {
          out.fields[f.key] = f.references.nodes
            .filter(n => n.__typename === 'Metaobject')
            .map(n => ({ id: n.id, handle: n.handle, type: n.type }));
          continue;
        }
        if (f.reference) {
          const r = f.reference;
          if (r.__typename === 'Metaobject') {
            out.fields[f.key] = { id: r.id, handle: r.handle, type: r.type };
          } else if (r.__typename === 'ProductVariant') {
            const sellingPlanIds = uniq(
              (r.sellingPlanAllocations?.nodes || [])
                .map(a => a?.sellingPlan?.id)
                .filter(Boolean)
                .map(stripGid)
            );
            out.fields[f.key] = {
              id: stripGid(r.id),
              productId: stripGid(r.product?.id),
              availableForSale: r.availableForSale,
              inventoryQuantity:
                typeof r.quantityAvailable === 'number' ? r.quantityAvailable : null,
              price: r.price,
              image: pickVariantImageOrProduct(r),
              collectionId: findMealBuilderCollectionId(r.product),
              sellingPlanIds,
              __typename: 'ProductVariant'
            };
          } else if (r.__typename === 'MediaImage') {
            out.fields[f.key] = {
              id: r.id,
              url: r.image?.url || null,
              altText: r.image?.altText || null,
              width: r.image?.width || null,
              height: r.image?.height || null,
              __typename: 'MediaImage'
            };
          } else if (r.__typename === 'GenericFile') {
            out.fields[f.key] = {
              id: r.id,
              url: r.url,
              mimeType: r.mimeType,
              __typename: 'GenericFile'
            };
          } else if (r.__typename === 'Collection') {
            out.fields[f.key] = {
              id: stripGid(r.id),
              handle: r.handle || null,
              title: r.title || null,
              __typename: 'Collection'
            };
          } else {
            out.fields[f.key] = null;
          }
          continue;
        }
        if (f.type === 'integer')
          out.fields[f.key] = f.value !== '' && f.value != null ? Number(f.value) : null;
        else if (f.type === 'decimal')
          out.fields[f.key] = f.value !== '' && f.value != null ? parseFloat(f.value) : null;
        else out.fields[f.key] = f.value;
      }
      return out;
    }

    function collectSellingPlanIdsFromVariantAllocations(v) {
      const ids = (v?.sellingPlanAllocations?.nodes || [])
        .map(n => n?.sellingPlan?.id)
        .filter(Boolean)
        .map(stripGid);
      return Array.from(new Set(ids));
    }

    function inflateProduct(node) {
      const variants = (node?.variants?.nodes || []).map(v => ({
        id: stripGid(v.id),
        title: v.title || '',
        price: v.price
          ? { amount: Number(v.price.amount || 0), currencyCode: v.price.currencyCode || 'GBP' }
          : { amount: 0, currencyCode: 'GBP' },
        image: v.image
          ? {
              url: v.image.url,
              altText: v.image.altText || null,
              width: v.image.width || null,
              height: v.image.height || null
            }
          : null,
        sellingPlanIds: collectSellingPlanIdsFromVariantAllocations(v),
        selectedOptions: v.selectedOptions || [],
        inventoryQuantity: typeof v.quantityAvailable === 'number' ? v.quantityAvailable : null
      }));

      const productSellingPlans = [];
      (node?.sellingPlanGroups?.nodes || []).forEach(g => {
        (g?.sellingPlans?.nodes || []).forEach(sp => {
          if (sp?.id) productSellingPlans.push(stripGid(sp.id));
        });
      });

      // Try to detect 3/5/7-day variants from selectedOptions first; fallback to title.
      const dayVariantMap = {};
      const parseDays = v => {
        // Look for option name/value containing "day"
        const so = v.selectedOptions || [];
        const byName = so.find(o => /day/i.test(o?.name || ''))?.value;
        const byValue = so.find(o => /day/i.test(o?.value || ''))?.value;
        const source = (byName || byValue || v.title || '').toLowerCase();
        const m = source.match(/\b(3|5|7)\b/);
        return m ? Number(m[1]) : null;
      };
      variants.forEach(v => {
        const d = parseDays(v);
        if (d) dayVariantMap[d] = v.id;
      });
      // Fallback to simple title heuristics if needed
      if (!dayVariantMap[3] || !dayVariantMap[5] || !dayVariantMap[7]) {
        variants.forEach(v => {
          const t = (v.title || '').toLowerCase();
          if (!dayVariantMap[3] && t.includes('3') && t.includes('day')) dayVariantMap[3] = v.id;
          if (!dayVariantMap[5] && t.includes('5') && t.includes('day')) dayVariantMap[5] = v.id;
          if (!dayVariantMap[7] && t.includes('7') && t.includes('day')) dayVariantMap[7] = v.id;
        });
      }

      return {
        productId: stripGid(node.id),
        handle: node.handle,
        title: node.title || '',
        variants,
        dayVariantMap,
        sellingPlanIds: Array.from(new Set(productSellingPlans))
      };
    }

    // Phased loading across references
    const mapById = new Map();
    const allIds = new Set();

    // Step 1: fetch groupings and weekly add-ons
    const step1 = await fetchNodes(baseIds);
    step1.forEach(n => {
      mapById.set(n.id, n);
      allIds.add(n.id);
    });

    // Collect meal_entry IDs from grouping.meals
    const entryIds = new Set();
    for (const n of step1) {
      if (n.__typename === 'Metaobject' && n.type === 'press_meal_plan_2025_meal_grouping') {
        for (const f of n.fields || []) {
          if (f.key === 'press_meal_plan_2025_meal_grouping.meals' || f.key === 'meals') {
            for (const ref of f.references?.nodes || []) {
              if (ref.__typename === 'Metaobject' && !allIds.has(ref.id)) entryIds.add(ref.id);
            }
          }
        }
      }
    }

    // Step 2: fetch meal_entry
    const step2 = await fetchNodes(entryIds);
    step2.forEach(n => {
      mapById.set(n.id, n);
      allIds.add(n.id);
    });

    // Collect meal IDs from any fetched meal_entry (both step1 and step2)
    const mealIds = new Set();
    const entriesToScan = [...step2, ...step1].filter(
      n => n.__typename === 'Metaobject' && n.type === 'meal_entry'
    );
    for (const n of entriesToScan) {
      for (const f of n.fields || []) {
        if (f.key === 'meal_entry.meal' || f.key === 'meal') {
          const r = f.reference;
          if (r?.__typename === 'Metaobject' && !allIds.has(r.id)) mealIds.add(r.id);
        }
      }
    }

    // Step 3: fetch meals
    const step3 = await fetchNodes(mealIds);
    step3.forEach(n => {
      mapById.set(n.id, n);
      allIds.add(n.id);
    });

    // Collect chef and variant IDs from meals
    const chefIds = new Set();
    const variantIds = new Set();
    for (const n of step3) {
      if (n.__typename === 'Metaobject' && n.type === 'press_meal_plan_2025_meal') {
        for (const f of n.fields || []) {
          if (f.key === 'press_meal_plan_2025_meal.chef' || f.key === 'chef') {
            const r = f.reference;
            if (r?.__typename === 'Metaobject' && !allIds.has(r.id)) chefIds.add(r.id);
          }
          if (f.key === 'press_meal_plan_2025_meal.product' || f.key === 'product') {
            const r = f.reference;
            if (r?.__typename === 'ProductVariant' && !allIds.has(r.id)) variantIds.add(r.id);
          }
        }
      }
    }

    // Step 4: fetch chefs and product variants
    const step4 = await fetchNodes(new Set([...chefIds, ...variantIds]));
    step4.forEach(n => {
      mapById.set(n.id, n);
      allIds.add(n.id);
    });

    // +++ Parent bundle product (prefer nodes cache first, then fallbacks)
    let bundleProduct = null;

    const variantGid = parentRef.variantId || parentVariantOverride || null;
    if (variantGid) {
      const vn = mapById.get(variantGid);
      if (vn && vn.__typename === 'ProductVariant') {
        const syntheticProduct = {
          __typename: 'Product',
          id: vn.product?.id || null,
          handle: vn.product?.handle || null,
          title: vn.product?.title || '',
          variants: { nodes: [vn] },
          sellingPlanGroups: { nodes: [] }
        };
        bundleProduct = inflateProduct(syntheticProduct);
      } else {
        // Rare fallback if variant wasn't returned in the initial nodes()
        const fetched = await fetchNodes(new Set([variantGid]));
        const vNode = fetched.find(n => n && n.__typename === 'ProductVariant');
        if (vNode) {
          const syntheticProduct = {
            __typename: 'Product',
            id: vNode.product?.id || null,
            handle: vNode.product?.handle || null,
            title: vNode.product?.title || '',
            variants: { nodes: [vNode] },
            sellingPlanGroups: { nodes: [] }
          };
          bundleProduct = inflateProduct(syntheticProduct);
        }
      }
    } else if (parentRef.id) {
      const pn = mapById.get(parentRef.id);
      if (pn && pn.__typename === 'Product') {
        bundleProduct = inflateProduct(pn);
      }
    }

    // Fallbacks (query by id / handle) only if still not found
    if (!bundleProduct && parentRef.id) {
      const pn = await fetchProductById(parentRef.id);
      if (pn) bundleProduct = inflateProduct(pn);
    }
    if (!bundleProduct && parentRef.handle) {
      let pn = await fetchProductByHandle(parentRef.handle);
      if (!pn) pn = await fetchProductByHandleViaJs(parentRef.handle);
      if (pn) bundleProduct = inflateProduct(pn);
    }

    log('bundleProduct inflated =', bundleProduct);

    // Inflate metaobjects and build id->handle map ONCE
    const inflatedMeta = [...mapById.values()]
      .filter(n => n.__typename === 'Metaobject')
      .map(inflateMetaobject);

    const metaIdToHandle = new Map(inflatedMeta.map(n => [n.id, n.handle]));

    // Normalize into dictionaries
    const groupings = {};
    const entries = {};
    const meals = {};
    const chefs = {};

    for (const n of inflatedMeta) {
      if (n.type === 'press_meal_plan_2025_meal_grouping') {
        const f = n.fields;
        const mealsRefs = f['press_meal_plan_2025_meal_grouping.meals'] ?? f['meals'] ?? [];

        // Read optional Collection reference (can be object with id/handle or a raw string)
        const rawGroupingCollection =
          f['press_meal_plan_2025_meal_grouping.grouping_collection'] ??
          f['grouping_collection'] ??
          null;

        let groupingCollectionId = null;
        if (rawGroupingCollection) {
          if (typeof rawGroupingCollection === 'object' && rawGroupingCollection.id) {
            groupingCollectionId = stripGid(rawGroupingCollection.id);
          } else if (typeof rawGroupingCollection === 'string') {
            groupingCollectionId = stripGid(rawGroupingCollection);
          }
        }

        groupings[n.handle] = {
          id: stripGid(n.id),
          handle: n.handle,
          name: f['press_meal_plan_2025_meal_grouping.name'] ?? f['name'] ?? null,
          namePlural:
            f['press_meal_plan_2025_meal_grouping.name_plural'] ?? f['name_plural'] ?? null,
          meals: mealsRefs.map(m => m.handle),
          // <<— carry the collection id so renderer can use it
          collectionId: groupingCollectionId
        };
      }
    }

    for (const n of inflatedMeta) {
      if (n.type === 'meal_entry') {
        const f = n.fields;
        entries[n.handle] = {
          id: stripGid(n.id),
          handle: n.handle,
          meal: (f['meal_entry.meal'] ?? f['meal'] ?? null)?.handle ?? null,
          maximumAllowed: f['meal_entry.maximum_allowed'] ?? f['maximum_allowed'] ?? null,
          initialQuantities: {
            allMeals3:
              f['meal_entry.all_meals_3_day_plan_initial_quantity'] ??
              f['all_meals_3_day_plan_initial_quantity'] ??
              null,
            allMeals5:
              f['meal_entry.all_meals_5_day_plan_initial_quantity'] ??
              f['all_meals_5_day_plan_initial_quantity'] ??
              null,
            allMeals7:
              f['meal_entry.all_meals_7_day_plan_initial_quantity'] ??
              f['all_meals_7_day_plan_initial_quantity'] ??
              null,
            plantBased3:
              f['meal_entry.plant_based_meals_only_3_day_plan_initial_quantity'] ??
              f['plant_based_meals_only_3_day_plan_initial_quantity'] ??
              null,
            plantBased5:
              f['meal_entry.plant_based_meals_only_5_day_plan_initial_quantity'] ??
              f['plant_based_meals_only_5_day_plan_initial_quantity'] ??
              null,
            plantBased7:
              f['meal_entry.plant_based_meals_only_7_day_plan_initial_quantity'] ??
              f['plant_based_meals_only_7_day_plan_initial_quantity'] ??
              null
          }
        };
      }
    }

    for (const n of inflatedMeta) {
      if (n.type === 'press_meal_plan_2025_meal') {
        const f = n.fields;
        const pv = f['press_meal_plan_2025_meal.product'] ?? f['product'] ?? null;
        const chefRef = f['press_meal_plan_2025_meal.chef'] ?? f['chef'] ?? null;

        meals[n.handle] = {
          id: stripGid(n.id),
          handle: n.handle,
          displayName: f['press_meal_plan_2025_meal.display_name'] ?? f['display_name'] ?? null,
          dietaryType: toStringArray(
            f['press_meal_plan_2025_meal.dietary_type'] ?? f['dietary_type']
          ),
          shortDescription:
            f['press_meal_plan_2025_meal.short_description'] ?? f['short_description'] ?? null,
          highlights: toStringArray(f['press_meal_plan_2025_meal.highlights'] ?? f['highlights']),
          calories: f['press_meal_plan_2025_meal.calories'] ?? f['calories'] ?? null,
          carbohydrates: f['press_meal_plan_2025_meal.carbohydrates'] ?? f['carbohydrates'] ?? null,
          protein: f['press_meal_plan_2025_meal.protein'] ?? f['protein'] ?? null,
          fats: f['press_meal_plan_2025_meal.fats'] ?? f['fats'] ?? null,
          portionSize: f['press_meal_plan_2025_meal.portion_size'] ?? f['portion_size'] ?? null,
          ingredients: f['press_meal_plan_2025_meal.ingredients'] ?? f['ingredients'] ?? null,
          allergens: f['press_meal_plan_2025_meal.allergens'] ?? f['allergens'] ?? null,
          chefsNotes: f['press_meal_plan_2025_meal.chefs_notes'] ?? f['chefs_notes'] ?? null,
          productVariant: pv
            ? {
                id: pv.id,
                productId: pv.productId,
                availableForSale: pv.availableForSale,
                inventoryQuantity:
                  typeof pv.inventoryQuantity === 'number' ? pv.inventoryQuantity : null, // ← добавили
                price: pv.price,
                image: pv.image
                  ? {
                      url: pv.image.url,
                      altText: pv.image.altText,
                      width: pv.image.width,
                      height: pv.image.height
                    }
                  : null,
                collectionId: pv.collectionId,
                sellingPlanIds: pv.sellingPlanIds
              }
            : null,
          chef: chefRef?.handle ?? null
        };
      }
    }

    for (const n of inflatedMeta) {
      if (n.type === 'press_meal_plan_2025_chef') {
        const f = n.fields;
        const img = f['press_meal_plan_2025_chef.image'] ?? f['image'] ?? null;
        let image = null;
        if (img && img.url) {
          image = {
            url: img.url,
            altText: img.altText || null,
            width: img.width || null,
            height: img.height || null
          };
        }
        chefs[n.handle] = {
          id: stripGid(n.id),
          handle: n.handle,
          name: f['press_meal_plan_2025_chef.name'] ?? f['name'] ?? null,
          image,
          link: f['press_meal_plan_2025_chef.link'] ?? f['link'] ?? null
        };
      }
    }

    // Convert plan weeks GID -> handle using single map
    const gidToHandle = gid => metaIdToHandle.get(gid) || gid;
    const planOut = JSON.parse(JSON.stringify(seed.plan));
    planOut.weeks.A = (planOut.weeks.A || []).map(gidToHandle);
    planOut.weeks.B = (planOut.weeks.B || []).map(gidToHandle);
    planOut.weeklyAddOns = (planOut.weeklyAddOns || []).map(gidToHandle);

    window.PRESS_MEAL_PLAN = { plan: planOut, groupings, entries, meals, chefs, bundleProduct };
    log('PRESS_MEAL_PLAN.bundleProduct =', window.PRESS_MEAL_PLAN.bundleProduct);
    log('PRESS_MEAL_PLAN', window.PRESS_MEAL_PLAN);
    return window.PRESS_MEAL_PLAN;
  }

  // =========================
  // Filtering module (window.MealBuilder.getData)
  // =========================
  function installFilteringModule() {
    const MB = (window.MealBuilder = window.MealBuilder || {});

    // Check plant-based or vegan flags inside meal.dietaryType
    function hasPlantBasedOrVegan(meal) {
      const types = Array.isArray(meal?.dietaryType) ? meal.dietaryType : [];
      return types.some(t => {
        const s = String(t).trim().toLowerCase();
        return s === 'plant based' || s === 'plant-based' || s === 'vegan';
      });
    }

    function computeInitialQuantity(entry, planDays, dietMode) {
      const q = entry?.initialQuantities || {};
      if (dietMode === 'plant-meals-only') {
        if (planDays === 3) return q.plantBased3 ?? null;
        if (planDays === 5) return q.plantBased5 ?? null;
        if (planDays === 7) return q.plantBased7 ?? null;
        return q.plantBased5 ?? q.plantBased3 ?? q.plantBased7 ?? null;
      } else {
        if (planDays === 3) return q.allMeals3 ?? null;
        if (planDays === 5) return q.allMeals5 ?? null;
        if (planDays === 7) return q.allMeals7 ?? null;
        return q.allMeals5 ?? q.allMeals3 ?? q.allMeals7 ?? null;
      }
    }

    function clampToMaximumAllowed(initialQty, maximumAllowed) {
      if (typeof initialQty !== 'number') return initialQty;
      if (typeof maximumAllowed !== 'number') return initialQty;
      return Math.min(initialQty, maximumAllowed);
    }

    // Public API: compute filtered data for given filters
    MB.getData = function getData(filters, source = window.PRESS_MEAL_PLAN) {
      const { week = 'A', diet = 'all-meals', days = 5 } = filters || {};
      const groupingHandles = source?.plan?.weeks?.[week] || [];
      const result = { week, diet, days, groupings: [] };

      for (const gh of groupingHandles) {
        const g = source.groupings[gh];
        if (!g) continue;

        const entries = [];
        for (const eh of g.meals || []) {
          const entry = source.entries[eh];
          if (!entry) continue;

          const meal = entry.meal ? source.meals[entry.meal] : null;
          if (!meal) continue;

          // Diet filter (strict Plant Based / Vegan)
          if (diet === 'plant-meals-only' && !hasPlantBasedOrVegan(meal)) continue;

          // Compute initial quantity and clamp to maximumAllowed
          let initialQuantity = computeInitialQuantity(entry, days, diet);
          initialQuantity = clampToMaximumAllowed(initialQuantity, entry.maximumAllowed);

          entries.push({
            handle: eh,
            maximumAllowed: entry.maximumAllowed ?? null,
            initialQuantity,
            meal: {
              handle: meal.handle,
              displayName: meal.displayName,
              shortDescription: meal.shortDescription || '',
              dietaryType: meal.dietaryType || [],
              highlights: meal.highlights || [],
              ingredients: meal.ingredients || '',
              allergens: meal.allergens || '',
              nutrition: {
                calories: meal.calories,
                carbohydrates: meal.carbohydrates,
                protein: meal.protein,
                fats: meal.fats,
                portionSize: meal.portionSize
              },
              productVariant: meal.productVariant
                ? {
                    id: meal.productVariant.id,
                    productId: meal.productVariant.productId,
                    availableForSale: meal.productVariant.availableForSale,
                    inventoryQuantity:
                      typeof meal.productVariant.inventoryQuantity === 'number'
                        ? meal.productVariant.inventoryQuantity
                        : null,
                    price: meal.productVariant.price,
                    image: meal.productVariant.image || null,
                    collectionId: meal.productVariant.collectionId || null,
                    sellingPlanIds: meal.productVariant.sellingPlanIds || []
                  }
                : null,
              chefHandle: meal.chef || null
            }
          });
        }

        result.groupings.push({
          handle: g.handle,
          name: g.name || g.handle,
          namePlural: g.namePlural || null,
          collectionId: g.collectionId ?? null,
          entries
        });
      }

      return result;
    };
  }

  // =========================
  // Controls wiring (listen buttons → compute → emit "mealbuilder:data")
  // =========================
  function installControls(dataReadyPromise) {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._controlsWired) return;

    // Per-preset cache: key = "diet|days|week" → data snapshot with user's selections
    MB._cacheByPreset = MB._cacheByPreset || {};

    const section = document.getElementById(SECTION_ID);
    const dietGroup = section.querySelector(DIET_GROUPSEL);
    const daysGroup = section.querySelector(DAYS_GROUPSEL);
    const weekGroup = section.querySelector('.meal-builder-main__week-selector');

    // Init state from DOM...
    MB.state = {
      week: WEEK_MAP[getSelectedValue(weekGroup, WEEK_BTN_SEL)] || 'A',
      diet: DIET_MAP[getSelectedValue(dietGroup, PLAN_BTN_SEL)] || 'all-meals',
      days: DAYS_MAP[getSelectedValue(daysGroup, PLAN_BTN_SEL)] || 5
    };

    // Compute + emit with optional cache preference
    async function computeAndEmit({ preferCache = false } = {}) {
      // Wait for data bootstrap
      if (dataReadyPromise) {
        await dataReadyPromise.catch(() => {});
      }

      const key = presetKey(MB.state);

      // If caller prefers cache and we have a snapshot for this (diet,days,week) — use it
      if (preferCache && MB._cacheByPreset[key]) {
        const snap = deepClone(MB._cacheByPreset[key]); // keep cache immutable
        MB._lastData = snap;
        section.dispatchEvent(
          new CustomEvent('mealbuilder:data', {
            detail: { state: { ...MB.state }, data: snap }
          })
        );
        log('mealbuilder:data (from cache)', { state: MB.state, data: snap });
        return;
      }

      // Otherwise recompute initial (do NOT seed cache here — cache represents user's saved selection)
      const data = MB.getData(MB.state);
      MB._lastData = data;
      section.dispatchEvent(
        new CustomEvent('mealbuilder:data', {
          detail: { state: { ...MB.state }, data }
        })
      );
      log('mealbuilder:data', { state: MB.state, data });
    }

    // Update the calories caption tooltip text based on the active week
    function updateCaloriesCaptionTooltip(week) {
      const el = document.querySelector(
        '.meal-builder-main__top-captions-caption-calories .tooltip'
      );
      if (!el) return;

      // Build the message for the specific week
      const txt =
        week === 'B'
          ? 'The average number of calories you will consume per day on Week 2’s Menu'
          : 'The average number of calories you will consume per day on Week 1’s Menu';

      // Update data attribute (for re-init cases) and live tippy instance if present
      el.setAttribute('data-tippy-content', txt);
      if (el._tippy && typeof el._tippy.setContent === 'function') {
        el._tippy.setContent(txt);
      }
    }

    // Diet changed → render initial (ignore any cache)
    dietGroup?.addEventListener('click', e => {
      const btn = e.target.closest(PLAN_BTN_SEL);
      if (!btn || !dietGroup.contains(btn) || btn.dataset.selected === 'true') return;
      toggleSelectionInGroup(dietGroup, btn, PLAN_BTN_SEL);
      MB.state.diet = DIET_MAP[btn.dataset.value] || 'all-meals';
      pulseGroupingsLoading();
      computeAndEmit({ preferCache: true }); // preferCache=true → initial
    });

    // Days changed → render initial (ignore any cache)
    daysGroup?.addEventListener('click', e => {
      const btn = e.target.closest(PLAN_BTN_SEL);
      if (!btn || !daysGroup.contains(btn) || btn.dataset.selected === 'true') return;
      toggleSelectionInGroup(daysGroup, btn, PLAN_BTN_SEL);
      MB.state.days = DAYS_MAP[btn.dataset.value] || 5;
      pulseGroupingsLoading();
      computeAndEmit({ preferCache: true }); // preferCache=true → initial
    });

    // Week changed (within the same diet+days) → try cache first
    weekGroup?.addEventListener('click', e => {
      const btn = e.target.closest(WEEK_BTN_SEL);
      if (!btn || !weekGroup.contains(btn) || btn.dataset.selected === 'true') return;
      toggleSelectionInGroup(weekGroup, btn, WEEK_BTN_SEL);
      MB.state.week = WEEK_MAP[btn.dataset.value] || 'A';

      // Update calories tooltip to reflect the selected week
      updateCaloriesCaptionTooltip(MB.state.week);

      pulseGroupingsLoading();
      computeAndEmit({ preferCache: true }); // try user's previous selection for this (diet,days,week
    });

    // --- Mobile week toggle ---
    const weekMobileBtn = section.querySelector('.meal-builder-main__week-selector-mobile-btn');

    // Reverse map to find desktop button by MB.state.week
    const WEEK_REV_MAP = { A: 'week-a-menu', B: 'week-b-menu' };

    // Update the mobile button label to always offer the "other" week
    function syncWeekMobileLabel() {
      if (!weekMobileBtn) return;
      const next = MB.state.week === 'A' ? '2' : '1';
      weekMobileBtn.textContent = `CHOOSE WEEK ${next} MENU`;
    }

    // Smoothly scroll the groupings container into view
    function scrollGroupingsIntoView() {
      const container = section.querySelector(GROUPINGS_SEL);
      if (!container) return;
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    weekMobileBtn?.addEventListener('click', e => {
      e.preventDefault();

      // Toggle week in state
      MB.state.week = MB.state.week === 'A' ? 'B' : 'A';

      // Keep desktop selector in sync (if present)
      const desktopBtnToSelect = weekGroup?.querySelector(
        `${WEEK_BTN_SEL}[data-value="${WEEK_REV_MAP[MB.state.week]}"]`
      );
      if (desktopBtnToSelect) {
        toggleSelectionInGroup(weekGroup, desktopBtnToSelect, WEEK_BTN_SEL);
      }

      // Reflect week change in calories tooltip and re-render (prefer cache)
      updateCaloriesCaptionTooltip(MB.state.week);
      pulseGroupingsLoading();
      computeAndEmit({ preferCache: true });

      // Update mobile button label and scroll to groupings
      syncWeekMobileLabel();
      scrollGroupingsIntoView();
    });

    // Initial label sync
    syncWeekMobileLabel();

    // Keep the mobile label synced when data is recomputed elsewhere
    section.addEventListener('mealbuilder:data', () => syncWeekMobileLabel());

    // Initial render is always initial (no cache)
    computeAndEmit();

    MB._controlsWired = true;
  }

  // =========================
  // Renderer (listen "mealbuilder:data" → render HTML into .meal-builder-main__groupings)
  // =========================
  function installRenderer() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._rendererWired) return;

    const section = document.getElementById(SECTION_ID);
    if (!section) {
      warn('[MealBuilder] Renderer: section not found');
      return;
    }
    const container = section.querySelector(GROUPINGS_SEL);
    if (!container) {
      warn('[MealBuilder] Renderer: container not found', GROUPINGS_SEL);
      return;
    }

    // group limit helper (doubles the limit for a specific collection)
    function groupLimitFor(group, baseDays) {
      // Collection '676975346050' uses double limit of the current days
      const isDouble = String(group?.collectionId || '') === '676975346050';
      return isDouble ? Math.max(0, toInt(baseDays, 0)) * 2 : Math.max(0, toInt(baseDays, 0));
    }

    // normalize defaults so total == effective group limit
    // and shift quantities from unavailable entries and from rows that exceed their per-row cap.
    function normalizeGroupDefaults(group, days) {
      // Effective target for this group (may be doubled for special collection)
      const target = groupLimitFor(group, days);

      if (!group || !Array.isArray(group.entries) || !group.entries.length) {
        return group?.entries || [];
      }

      // Build working rows with effective max (entry.max ∩ inventory if known)
      const rows = group.entries.map((e, idx) => {
        const pv = e?.meal?.productVariant || null;

        // Base max from entry (0 or null = unlimited in UI semantics)
        const entryMax = toInt(e.maximumAllowed, 0);

        // Inventory quantity (hard cap if present)
        const invQtyRaw = pv?.inventoryQuantity;
        const invQty =
          typeof invQtyRaw === 'number' && Number.isFinite(invQtyRaw)
            ? Math.max(0, Math.floor(invQtyRaw))
            : null;

        // Effective per-row cap:
        // - if inventory is known: it is a hard cap; if entryMax>0 → take min(entryMax, invQty)
        // - if inventory is unknown: use entryMax (0 = unlimited)
        let effectiveMax;
        if (invQty != null) {
          effectiveMax = entryMax > 0 ? Math.min(entryMax, invQty) : invQty;
        } else {
          effectiveMax = entryMax; // 0 means unlimited
        }

        // Persist cap back for UI (0 keeps "unlimited" semantics in data-maximum-allowed)
        e.maximumAllowed = effectiveMax > 0 ? effectiveMax : 0;

        // Availability flag
        const avail = pv ? String(pv.availableForSale).toLowerCase() !== 'false' : true;

        return {
          idx,
          entry: e,
          qty: toInt(e.initialQuantity, 0),
          // capLimit used in math; Infinity means "unlimited"
          capLimit: effectiveMax > 0 ? effectiveMax : Number.POSITIVE_INFINITY,
          avail
        };
      });

      const n = rows.length;

      // How much more fits into row i
      const capAt = i => Math.max(0, rows[i].capLimit - rows[i].qty);

      // Add up to "want" into row i; return remainder
      const addTo = (i, want) => {
        const cap = capAt(i);
        const take = Math.min(want, cap);
        if (take > 0) rows[i].qty += take;
        return want - take;
      };

      // Redistribute `amount` from index `fromIndex` to nearest available neighbours
      const redistributeNearest = (fromIndex, amount) => {
        let remaining = amount;
        for (let r = 1; remaining > 0 && (fromIndex - r >= 0 || fromIndex + r < n); r++) {
          if (fromIndex - r >= 0 && rows[fromIndex - r].avail) {
            remaining = addTo(fromIndex - r, remaining);
          }
          if (remaining <= 0) break;
          if (fromIndex + r < n && rows[fromIndex + r].avail) {
            remaining = addTo(fromIndex + r, remaining);
          }
        }
        return remaining;
      };

      // 1) Move defaults from unavailable entries to the closest available ones
      rows.forEach((row, i) => {
        if (!row.avail && row.qty > 0) {
          const leftover = redistributeNearest(i, row.qty);
          rows[i].qty = 0; // nothing stays on unavailable rows
          // if leftover > 0 here, there's no capacity elsewhere; we just drop it
        }
      });

      // 2) Hard-clamp every row to its per-row cap and redistribute the overflow
      rows.forEach((row, i) => {
        if (!row.avail) return;
        if (row.qty > row.capLimit) {
          const overflow = row.qty - row.capLimit;
          row.qty = row.capLimit; // clamp to cap
          const rem = redistributeNearest(i, overflow); // try to place the overflow nearby
          // if rem > 0, all neighbours are at capacity — overflow is dropped
        }
      });

      // 3) Make the total exactly equal to the group target (respecting capacities)
      let current = rows.filter(r => r.avail).reduce((acc, r) => acc + r.qty, 0);

      if (current < target) {
        // We need to add items: fill left→right, then right→left for fairness
        let need = target - current;
        for (let i = 0; i < n && need > 0; i++) {
          if (!rows[i].avail) continue;
          need = addTo(i, need);
        }
        for (let i = n - 1; i >= 0 && need > 0; i--) {
          if (!rows[i].avail) continue;
          need = addTo(i, need);
        }
      } else if (current > target) {
        // We need to remove items: trim from the tail
        let cut = current - target;
        for (let i = n - 1; i >= 0 && cut > 0; i--) {
          if (!rows[i].avail) continue;
          const dec = Math.min(rows[i].qty, cut);
          rows[i].qty -= dec;
          cut -= dec;
        }
      }

      // 4) Persist normalized quantities back to entries
      group.entries = rows.map(r => {
        r.entry.initialQuantity = Math.max(0, r.qty);
        return r.entry;
      });

      return group.entries;
    }

    function buildGroupingHTML(group) {
      // Ensure defaults respect effective group limit (days or 2*days for special collection)
      const daysNow = toInt(window.MealBuilder?.state?.days, 5);
      normalizeGroupDefaults(group, daysNow);

      // If the group provides a specific collection, prefer it over product's own collection
      const groupCollectionId = group.collectionId || null;
      const title = esc(group.name || group.handle);
      const btnText = esc(`${CHANGE_PREFIX}${group.namePlural || group.name || group.handle}`);
      const changeIconUrl =
        (window.customMealBuilderIcons &&
          window.customMealBuilderIcons.change_meals_btn_icon_svg) ||
        'https://cdn.shopify.com/s/files/1/2958/7314/files/change-meals-btn-icon.svg?v=1764763603';

      // Build only slides with initialQty > 0 (already normalized above)
      const slides = (group.entries || [])
        .filter(entry => toInt(entry.initialQuantity, 0) > 0)
        .map(entry => {
          const m = entry.meal || {};
          const pv = m.productVariant || null;

          // Values
          const displayName = m.displayName || m.handle || entry.handle || '';
          const titleId = `mb-card-title-${idify(m.handle || entry.handle || displayName)}`;
          const initialQty = toInt(entry.initialQuantity, 0);
          const maxAllowed = toInt(entry.maximumAllowed, 0);
          const image = pv?.image || null;
          const imageSrc = image?.url || '';
          const imageAlt = displayName;
          const dietaryFirst =
            Array.isArray(m.dietaryType) && m.dietaryType.length ? String(m.dietaryType[0]) : '';
          const dietaryIcon = dietaryIconSrc(dietaryFirst);
          const dietaryTooltipContentText = dietaryTooltipContent(dietaryFirst);
          const highlights = Array.isArray(m.highlights) ? m.highlights.slice(0, 2) : [];
          const calories = toInt(m.nutrition?.calories ?? m.calories, null);
          const carbs = toNum(m.nutrition?.carbohydrates ?? m.carbohydrates, null);
          const protein = toNum(m.nutrition?.protein ?? m.protein, null);
          const shortDescHtml = richTextToHTML(m.shortDescription || '');

          // Data attributes for <article>
          const dataAttrs = `
                        data-initial-quantity="${esc(initialQty)}"
                        data-maximum-allowed="${esc(maxAllowed)}"
                        data-available-for-sale="${esc(pv ? pv.availableForSale : '')}"
                        data-collection-id="${esc(groupCollectionId || pv?.collectionId || '')}"
                        data-variant-id="${esc(pv?.id || '')}"
                        data-product-id="${esc(pv?.productId || '')}"
                    `;

          // Nutrition labels (format with units)
          const calHtml =
            calories != null && calories !== ''
              ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-calories">${esc(calories)} cal</span>`
              : '';
          const carbsHtml =
            carbs != null && carbs !== ''
              ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-carbs">${esc(carbs)}g carbs</span>`
              : '';
          const proteinHtml =
            protein != null && protein !== ''
              ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-protein">${esc(protein)}g protein</span>`
              : '';

          const highlightsHtml = highlights
            .map(
              h =>
                `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-highlight">${esc(h)}</span>`
            )
            .join('');

          // Dietary icon block
          const dietaryHtml = dietaryIcon
            ? `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false">
                 <img src="${dietaryIcon}" alt="${esc(dietaryFirst)}" loading="lazy">
               </div>`
            : `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false"></div>`;

          return `
            <div class="swiper-slide meal-builder-main-grouping__products-slide"
                 data-entry-handle="${esc(entry.handle)}"
                 data-meal-handle="${esc(m.handle || '')}">
              <article class="meal-builder-main-product-card" role="group" aria-labelledby="${esc(titleId)}"
                       ${dataAttrs}>
                <div class="meal-builder-main-product-card__image">
                  <!-- PRODUCT CARD QUANTITY SELECTED -->
                  <div class="meal-builder-main-product-card__quantity-selected"
                       aria-live="polite"
                       aria-label="Selected quantity: ${esc(initialQty)}">
                    <span class="meal-builder-main-product-card__quantity-selected-label">x${esc(initialQty)}</span>
                  </div>

                  <!-- PRODUCT CARD IMAGE -->
                  <div class="product-info-popup-trigger meal-builder-main-product-card__image-link"
                       data-meal-handle="${esc(m.handle || '')}"
                  >
                    <img
                      src="${esc(imageSrc)}"
                      alt="${esc(imageAlt)}"
                      class="meal-builder-main-product-card__image-img"
                      loading="lazy"
                    >
                  </div>

                  <!-- PRODUCT CARD DIETARY TYPE -->
                  ${dietaryHtml}

                  <!-- PRODUCT CARD BUTTON INFO DESKTOP -->
                  <button
                    onclick="customMealShowPopup()"
                    class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--desktop product-info-popup-trigger"
                    type="button"
                    aria-label="More information"
                    data-meal-handle="${esc(m.handle || '')}"
                  >
                    <img src="${infoTooltipIconUrl}" alt="" loading="lazy" aria-hidden="true">
                  </button>

                  <!-- PRODUCT CARD QUANTITY MOBILE -->
                  <!--
                  <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--mobile">
                    <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                    <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="visually-hidden">Qty</label>
                    <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="meal-builder-main-product-card__quantity-input" value="${esc(initialQty)}" />
                    <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
                  </div>
                  -->
                </div>

                <!-- PRODUCT CARD INFO -->
                <div class="meal-builder-main-product-card__info">
                  <header class="meal-builder-main-product-card__info-header">
                    <!-- PRODUCT CARD TITLE -->
                    <div class="product-info-popup-trigger"
                         data-meal-handle="${esc(m.handle || '')}"
                    >
                      <h3 id="${esc(titleId)}" class="meal-builder-main-product-card__info-title">
                        ${esc(displayName)}
                      </h3>
                    </div>

                    <!-- PRODUCT CARD BUTTON INFO MOBILE -->
                    <button
                      onclick="customMealShowPopup()"
                      class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--mobile product-info-popup-trigger"
                      type="button"
                      aria-label="More information"
                      data-meal-handle="${esc(m.handle || '')}"
                    >
                      <img src="${infoTooltipIconUrl}" alt="More information" aria-hidden="true">
                    </button>
                  </header>

                  <!-- PRODUCT CARD NUTRITION -->
                  <div class="meal-builder-main-product-card__info-nutrition">
                    ${calHtml}${carbsHtml}${proteinHtml}${highlightsHtml}
                  </div>

                  <!-- PRODUCT CARD SHORT DESCRIPTION -->
                  <div class="meal-builder-main-product-card__info-short-description">
                    ${shortDescHtml}
                  </div>

                  <!-- PRODUCT CARD QUANTITY DESKTOP -->
                  <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--desktop">
                    <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                    <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="visually-hidden">Qty</label>
                    <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="meal-builder-main-product-card__quantity-input" value="${esc(initialQty)}" />
                    <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
                  </div>
                </div>
              </article>
            </div>`;
        })
        .join('');

      return `
        <div class="meal-builder-main-grouping" data-grouping="${esc(group.handle)}" data-group-collection-id="${esc(groupCollectionId || '')}">
          <div class="meal-builder-main-grouping__heading">
            <h4 class="meal-builder-main-grouping__heading-title">${title}</h4>
            <div class="meal-builder-main-grouping__heading-nav">
              <button onclick="customMealShowPopup('grouping')" type="button" class="meal-builder-main-grouping__heading-btn" data-value="change-${esc((group.namePlural || group.name || '').toLowerCase().replace(/\s+/g, '-'))}">
                <span class="icon">
                  <img src="${changeIconUrl}" alt="" loading="lazy">
                </span>
                <span class="text">${btnText}</span>
              </button>

              <div class="swiper-button swiper-button__prev">${ARROW_PREV}</div>
              <div class="swiper-button swiper-button__next">${ARROW_NEXT}</div>
            </div>
          </div>

          <div class="meal-builder-main-grouping__products">
            <div class="swiper _swiper meal-builder-main-grouping__products-swiper">
              <div class="swiper-wrapper">
                ${slides}
              </div>
            </div>
          </div>
        </div>
      `;
    }

    function renderGroupingsInto(data) {
      const groups = data?.groupings || [];
      const html = groups.map(buildGroupingHTML).join('') || '<!-- no groups -->';
      container.innerHTML = html;

      // Initialize Swiper when available (only >= 550px as per example)
      if (window.Swiper) {
        container.querySelectorAll('.meal-builder-main-grouping__products-swiper').forEach(swEl => {
          let swiper;
          const slidesCount = swEl.querySelectorAll('.swiper-slide').length;
          const initSwiper = () => {
            swiper = new Swiper(swEl, {
              spaceBetween: 10,
              slidesPerView: 2.05,
              navigation: {
                nextEl: swEl
                  .closest('.meal-builder-main-grouping')
                  .querySelector('.swiper-button__next'),
                prevEl: swEl
                  .closest('.meal-builder-main-grouping')
                  .querySelector('.swiper-button__prev')
              },
              breakpoints: {
                740: {
                  slidesPerView: 3.05,
                  navigation: {
                    enabled: slidesCount > 3 ? true : false
                  }
                },
                1024: {
                  slidesPerView: 2.05,
                  navigation: {
                    enabled: slidesCount > 2 ? true : false
                  }
                },
                1180: {
                  slidesPerView: 3.05,
                  navigation: {
                    enabled: slidesCount > 3 ? true : false
                  }
                }
              }
            });
          };
          const destroySwiper = () => {
            if (swiper) {
              swiper.destroy(true, true);
              swiper = null;
            }
          };
          const mql = window.matchMedia('(min-width: 550px)');
          const handleResize = e => {
            if (e.matches) {
              if (!swiper) initSwiper();
            } else {
              destroySwiper();
            }
          };
          handleResize(mql);
          mql.addEventListener('change', handleResize);
        });
      }

      // Emit rendered event (if you need to hook extra behavior)
      container.dispatchEvent(
        new CustomEvent('mealbuilder:rendered', { detail: { count: groups.length } })
      );
    }

    // Subscribe to data updates
    section.addEventListener('mealbuilder:data', e => {
      renderGroupingsInto(e.detail?.data);

      // First paint guard: remove the "loading" class only once after initial render
      if (!MB._firstPaintDone) {
        section.classList.remove('loading');
        MB._firstPaintDone = true;
      }
    });

    MB._rendererWired = true;
  }

  // =========================
  // Calories counter (listen "mealbuilder:data" → compute average daily calories)
  // =========================
  function installCaloriesCounter() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._caloriesWired) return;

    const section = document.getElementById(SECTION_ID);
    if (!section) return;

    // sum calories from add-ons cards currently on the page
    function computeAddOnsCalories() {
      const addOnsSection = document.querySelector('.meal-builder-main__add-ons-section');
      if (!addOnsSection) return 0;

      let sum = 0;
      addOnsSection
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          if (qty <= 0) return;

          // Prefer data-calories for speed; fallback to PRESS_MEAL_PLAN lookup by meal handle
          let cal = toNum(card.dataset.calories, null);
          if (cal == null) {
            const mh = card.dataset.mealHandle;
            const meal = window.PRESS_MEAL_PLAN?.meals?.[mh];
            cal = toNum(meal?.nutrition?.calories ?? meal?.calories, 0) || 0;
          }
          sum += qty * cal;
        });
      return sum;
    }

    // Compute initial quantity for an add-on entry based on current plan days/diet
    function initialQtyForAddOn(entry, planDays, dietMode) {
      const q = entry?.initialQuantities || {};
      if (dietMode === 'plant-meals-only') {
        if (planDays === 3) return q.plantBased3 ?? 0;
        if (planDays === 5) return q.plantBased5 ?? 0;
        if (planDays === 7) return q.plantBased7 ?? 0;
        return q.plantBased5 ?? q.plantBased3 ?? q.plantBased7 ?? 0;
      } else {
        if (planDays === 3) return q.allMeals3 ?? 0;
        if (planDays === 5) return q.allMeals5 ?? 0;
        if (planDays === 7) return q.allMeals7 ?? 0;
        return q.allMeals5 ?? q.allMeals3 ?? q.allMeals7 ?? 0;
      }
    }

    // Sum calories over add-ons (uses MB.state.addOnsQuantities if user changed values)
    function sumAddOnsCalories(days, diet) {
      const source = window.PRESS_MEAL_PLAN || {};
      const handles = source?.plan?.weeklyAddOns || [];
      let total = 0;

      // Small helper: process single entry handle
      const processEntry = eh => {
        const entry = source.entries?.[eh];
        if (!entry) return;

        const meal = entry.meal ? source.meals?.[entry.meal] : null;
        if (!meal) return;

        // User-chosen quantity has priority, otherwise derive from initial quantities
        let qty =
          MB.state?.addOnsQuantities &&
          Object.prototype.hasOwnProperty.call(MB.state.addOnsQuantities, eh)
            ? toInt(MB.state.addOnsQuantities[eh], 0)
            : toInt(initialQtyForAddOn(entry, days, diet), 0);

        // Respect maximumAllowed when present
        const maxAllowed = toInt(entry.maximumAllowed, 0);
        if (maxAllowed > 0) qty = Math.min(qty, maxAllowed);
        qty = Math.max(0, qty);

        // Calories per meal
        const cal = toNum(meal?.nutrition?.calories ?? meal?.calories, 0) || 0;
        total += qty * cal;
      };

      // weeklyAddOns may contain entry handles or grouping handles → support both
      for (const h of handles) {
        if (source.entries?.[h]) {
          processEntry(h);
        } else if (source.groupings?.[h]) {
          (source.groupings[h].meals || []).forEach(processEntry);
        }
      }

      return total;
    }

    // Compute average daily calories from current selected entries (main groupings + add-ons)
    function computeAvgDailyCalories(data) {
      const days = toInt(data?.days ?? MB?.state?.days, 0) || 1;

      let total = 0;
      // Main groups (existing logic)
      (data?.groupings || []).forEach(g => {
        (g.entries || []).forEach(e => {
          const qty = toInt(e.initialQuantity, 0);
          if (qty > 0) {
            const meal = e.meal || {};
            const cal = toNum(meal?.nutrition?.calories ?? meal?.calories, 0) || 0;
            total += qty * cal;
          }
        });
      });

      // add-ons contribution
      total += computeAddOnsCalories();

      // Round to nearest integer for a clean UI number
      const avg = Math.round(total / Math.max(1, days));
      return avg;
    }

    // Render into all .calories-counter elements on the page
    function render(data) {
      const avg = computeAvgDailyCalories(data);
      document.querySelectorAll('.calories-counter').forEach(el => {
        el.textContent = `${avg} cal`;
      });
    }

    // Recompute on every core data recompute (week/diet/days or popup save)
    section.addEventListener('mealbuilder:data', e => {
      render(e.detail?.data);
    });

    // Recompute when add-ons quantities change
    section.addEventListener('mealbuilder:addons-changed', () => {
      if (MB._lastData) render(MB._lastData);
    });

    MB.CaloriesCounter = {
      refresh() {
        if (MB._lastData) render(MB._lastData);
      }
    };

    // Initial render if data already exists
    if (MB._lastData) render(MB._lastData);

    MB._caloriesWired = true;
  }

  // =========================
  // Weekly Add-Ons section (render into .meal-builder-main__add-ons-section)
  // =========================
  function installAddOnsSection(dataReadyPromise) {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._addonsWired) return;

    // Host element for the Weekly Add-Ons block
    const host = document.querySelector('.meal-builder-main__add-ons-section');
    if (!host) {
      MB._addonsWired = true;
      return;
    }

    // Format as £0.00
    const fmtGBP = n => `£${Number(n || 0).toFixed(2)}`;

    // Resolve handles that can be entry handles, meal handles, or grouping handles
    function resolveWeeklyAddOnEntryHandles() {
      const src = window.PRESS_MEAL_PLAN || {};
      const arr = src?.plan?.weeklyAddOns || [];
      const out = [];

      arr.forEach(h => {
        if (src.entries?.[h]) {
          // Entry handle
          out.push(h);
        } else if (src.meals?.[h]) {
          // Meal handle (your plan format)
          out.push(h);
        } else if (src.groupings?.[h]) {
          // Grouping → expand to entries
          (src.groupings[h].meals || []).forEach(eh => {
            if (src.entries?.[eh]) out.push(eh);
          });
        }
      });

      return Array.from(new Set(out));
    }

    // Build single add-on CARD (article) for either entry handle or meal handle
    function buildAddOnCardHTML(handle, source) {
      const isEntry = !!source.entries?.[handle];
      const entry = isEntry ? source.entries[handle] : null;
      const mealHandle = isEntry ? entry.meal : handle;
      const meal = source.meals?.[mealHandle];
      if (!meal) return '';

      const pv = meal.productVariant || null;

      const displayName = meal.displayName || meal.handle || handle || '';
      const titleId = `mb-addon-title-${idify(meal.handle || handle || displayName)}`;

      const unitAmount = toNum(pv?.price?.amount, 0) || 0;
      const unitPriceTxt = unitAmount > 0 ? `£${unitAmount.toFixed(2)}/week` : '';

      // --- INVENTORY-AWARE MAX LOGIC (same spirit as normalizeGroupDefaults) ---
      // 1) entry.maximumAllowed: 0/null => unlimited in UI semantics
      const entryMax = isEntry ? toInt(entry.maximumAllowed, 0) : 0;

      // 2) inventoryQuantity (hard cap if present)
      const invQtyRaw = pv?.inventoryQuantity;
      const invQty =
        typeof invQtyRaw === 'number' && Number.isFinite(invQtyRaw)
          ? Math.max(0, Math.floor(invQtyRaw))
          : null;

      // 3) effective per-card cap:
      //    - if inv known → hard cap; if entryMax>0 → min(entryMax, invQty); else → invQty
      //    - if inv unknown → use entryMax as-is (0 = unlimited)
      let effectiveMax;
      if (invQty != null) {
        effectiveMax = entryMax > 0 ? Math.min(entryMax, invQty) : invQty;
      } else {
        effectiveMax = entryMax; // 0 means unlimited
      }

      // This is what the UI clamps to. Keep 0 to mean "unlimited".
      const maxAllowedForUI = effectiveMax > 0 ? effectiveMax : 0;

      const image = pv?.image || null;
      const imageSrc = image?.url || '';
      const imageAlt = displayName;

      const firstDiet =
        Array.isArray(meal.dietaryType) && meal.dietaryType.length
          ? String(meal.dietaryType[0])
          : '';
      const dietIcon = dietaryIconSrc(firstDiet);

      const calories = toInt(meal.nutrition?.calories ?? meal.calories, null);
      const carbs = toNum(meal.nutrition?.carbohydrates ?? meal.carbohydrates, null);
      const protein = toNum(meal.nutrition?.protein ?? meal.protein, null);
      const highlights = Array.isArray(meal.highlights) ? meal.highlights.slice(0, 2) : [];
      const shortDesc = richTextToHTML(meal.shortDescription || '');

      // Add-ons start with quantity 0 visually. Clamping happens via data-maximum-allowed.
      const dataAttrs = `
            data-entry-handle="${esc(handle)}"
            data-maximum-allowed="${esc(maxAllowedForUI)}"
            data-available-for-sale="${esc(pv ? pv.availableForSale : '')}"
            data-variant-id="${esc(pv?.id || '')}"
            data-product-id="${esc(pv?.productId || '')}"
            data-unit-price="${esc(unitAmount)}"
            data-collection-id="${esc(pv?.collectionId || '')}"
          `;

      const calHtml =
        calories != null && calories !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-calories">${esc(calories)} cal</span>`
          : '';
      const carbsHtml =
        carbs != null && carbs !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-carbs">${esc(carbs)}g carbs</span>`
          : '';
      const proteinHtml =
        protein != null && protein !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-protein">${esc(protein)}g protein</span>`
          : '';
      const highlightsHtml = highlights
        .map(
          h =>
            `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-highlight">${esc(h)}</span>`
        )
        .join('');

      const dietaryHtml = dietIcon
        ? `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false">
         <img src="${dietIcon}" alt="${esc(firstDiet)}" loading="lazy">
       </div>`
        : `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false"></div>`;

      return `
            <article class="meal-builder-main-product-card meal-builder-main-product-card--add-on"
              role="group"
              aria-labelledby="${esc(titleId)}"
              ${dataAttrs}
              data-meal-handle="${esc(meal.handle || '')}"
              data-calories="${esc(calories ?? '')}">
              <div class="meal-builder-main-product-card__image">
                <div class="meal-builder-main-product-card__quantity-selected" aria-live="polite" aria-label="Selected quantity: 0">
                  <span class="meal-builder-main-product-card__quantity-selected-label">x0</span>
                </div>

                <div class="product-info-popup-trigger meal-builder-main-product-card__image-link"
                     data-meal-handle="${esc(meal.handle || '')}">
                  <img src="${esc(imageSrc)}" alt="${esc(imageAlt)}" class="meal-builder-main-product-card__image-img" loading="lazy">
                </div>

                ${dietaryHtml}

                <button onclick="customMealShowPopup()"
                        class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--desktop product-info-popup-trigger"
                        type="button" aria-label="More information"
                        data-meal-handle="${esc(meal.handle || '')}">
                  <img src="${infoTooltipIconUrl}" alt="" loading="lazy" aria-hidden="true">
                </button>

                <!--
                <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--mobile">
                  <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                  <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="visually-hidden">Qty</label>
                  <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="meal-builder-main-product-card__quantity-input" value="0" />
                  <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
                </div>
                -->
              </div>

              <div class="meal-builder-main-product-card__info">
                <header class="meal-builder-main-product-card__info-header">
                  <div class="product-info-popup-trigger" data-meal-handle="${esc(meal.handle || '')}">
                    <h3 id="${esc(titleId)}" class="meal-builder-main-product-card__info-title">${esc(displayName)}</h3>
                  </div>

                  <button onclick="customMealShowPopup()"
                          class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--mobile product-info-popup-trigger"
                          type="button" aria-label="More information"
                          data-meal-handle="${esc(meal.handle || '')}">
                    <img src="${infoTooltipIconUrl}" alt="More information" aria-hidden="true">
                  </button>

                  <div class="meal-builder-main-product-card__info-price">${esc(unitPriceTxt)}</div>
                </header>

                <div class="meal-builder-main-product-card__info-nutrition">
                  ${calHtml}${carbsHtml}${proteinHtml}${highlightsHtml}
                </div>

                <div class="meal-builder-main-product-card__info-short-description">
                  ${shortDesc}
                </div>

                <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--desktop">
                  <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                  <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="visually-hidden">Qty</label>
                  <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="meal-builder-main-product-card__quantity-input" value="0" />
                  <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
                </div>
              </div>
            </article>
          `;
    }

    // Wrap the card into a swiper slide
    function buildAddOnSlideHTML(handle, source) {
      const card = buildAddOnCardHTML(handle, source);
      if (!card) return '';
      return `
      <div class="swiper-slide meal-builder-main-grouping__products-slide" data-addon-handle="${esc(handle)}">
        ${card}
      </div>
    `;
    }

    // Update "+£X.XX/week" in the heading (hide if zero)
    function updateHeaderPrice() {
      const priceEl = host.querySelector('.meal-builder-main-grouping__heading-price');
      if (!priceEl) return;

      let total = 0;
      host
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          const unit = toNum(card.dataset.unitPrice, 0) || 0;
          total += qty * unit;
        });

      if (total > 0) {
        priceEl.textContent = `+${fmtGBP(total)}/week`;
        showEl(priceEl);
      } else {
        hideEl(priceEl);
      }

      // update calories counter when price (i.e., quantities) change
      window.MealBuilder?.CaloriesCounter?.refresh?.();

      const sectionEl = document.getElementById(SECTION_ID);
      sectionEl?.dispatchEvent(
        new CustomEvent('mealbuilder:addons-changed', { detail: { total } })
      );
    }

    // Clamp helper honoring "maximum allowed" (0 = unlimited)
    const clampByMax = (card, val) => {
      const maxAllowed = toInt(card.dataset.maximumAllowed, 0);
      let v = Math.max(0, toInt(val, 0));
      if (maxAllowed > 0) v = Math.min(v, maxAllowed);
      return v;
    };

    // Apply value into inputs + bubble + state class
    const setCardValue = (card, val) => {
      const v = clampByMax(card, val);
      card
        .querySelectorAll('.meal-builder-main-product-card__quantity-input')
        .forEach(inp => (inp.value = v));
      const bubble = card.querySelector('.meal-builder-main-product-card__quantity-selected-label');
      if (bubble) bubble.textContent = `x${v}`;
      card.classList.toggle('has-quantity', v > 0);
      return v;
    };

    // Add event wiring inside this add-ons section (with AbortController to avoid dupes)
    function wireQuantity(root) {
      if (root._mbAddOnsCtl) {
        try {
          root._mbAddOnsCtl.abort();
        } catch (_) {}
      }
      root._mbAddOnsCtl = new AbortController();
      const { signal } = root._mbAddOnsCtl;

      // Disable unavailable cards on init
      root
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const available = String(card.dataset.availableForSale || '').toLowerCase() !== 'false';
          const qtyBlocks = card.querySelectorAll('.meal-builder-main-product-card__quantity');
          const inputs = card.querySelectorAll('.meal-builder-main-product-card__quantity-input');
          const decs = card.querySelectorAll('.decrease-quantity-btn');
          const incs = card.querySelectorAll('.increase-quantity-btn');

          if (!available) {
            setCardValue(card, 0);
            qtyBlocks.forEach(q => q.setAttribute('aria-disabled', 'true'));
            inputs.forEach(i => {
              i.value = 0;
              i.disabled = true;
            });
            decs.forEach(b => (b.disabled = true));
            incs.forEach(b => (b.disabled = true));
            card.classList.add('is-unavailable');
          }
        });

      // + / − buttons
      root.addEventListener(
        'click',
        e => {
          const inc = e.target.closest('.increase-quantity-btn');
          const dec = e.target.closest('.decrease-quantity-btn');
          if (!inc && !dec) return;

          const card = e.target.closest(
            '.meal-builder-main-product-card.meal-builder-main-product-card--add-on'
          );
          if (!card || String(card.dataset.availableForSale || '').toLowerCase() === 'false')
            return;

          const current = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          const next = clampByMax(card, current + (inc ? 1 : -1));
          setCardValue(card, next);
          updateHeaderPrice();
        },
        { capture: true, signal }
      );

      // Manual input typing
      const onEdit = e => {
        if (!e.target.matches('.meal-builder-main-product-card__quantity-input')) return;
        const card = e.target.closest(
          '.meal-builder-main-product-card.meal-builder-main-product-card--add-on'
        );
        if (!card) return;
        setCardValue(card, e.target.value);
        updateHeaderPrice();
      };
      root.addEventListener('input', onEdit, { capture: true, signal });
      root.addEventListener('change', onEdit, { capture: true, signal });

      // Initial price compute
      updateHeaderPrice();
    }

    // Render the add-ons block; hide host if there are no add-ons
    function renderAddOns() {
      const src = window.PRESS_MEAL_PLAN || {};
      const handles = resolveWeeklyAddOnEntryHandles();

      if (!handles.length) {
        hideEl(host);
        return;
      }
      showEl(host);

      const slides = handles.map(h => buildAddOnSlideHTML(h, src)).join('');

      host.innerHTML = `
      <div class="meal-builder-main-grouping" data-grouping="weekly-add-ons">
        <div class="meal-builder-main-grouping__heading">
          <h4 class="meal-builder-main-grouping__heading-title">Weekly Add Ons</h4>
          <div class="meal-builder-main-grouping__heading-nav">
            <div class="meal-builder-main-grouping__heading-price" style="display:none"></div>
            <div class="swiper-button swiper-button__prev">${ARROW_PREV}</div>
            <div class="swiper-button swiper-button__next">${ARROW_NEXT}</div>
          </div>
        </div>

        <div class="meal-builder-main-grouping__products meal-builder-main-grouping__products--add-on">
          <div class="swiper _swiper meal-builder-main-grouping__products-swiper">
            <div class="swiper-wrapper">
              ${slides}
            </div>
          </div>
        </div>
      </div>
    `;

      // Init swiper (same breakpoints as main renderer)
      const swEl = host.querySelector('.meal-builder-main-grouping__products-swiper');
      if (window.Swiper && swEl) {
        let swiper;
        const initSwiper = () => {
          swiper = new Swiper(swEl, {
            spaceBetween: 10,
            slidesPerView: 1.35,
            navigation: {
              enabled: false,
              nextEl: swEl
                .closest('.meal-builder-main-grouping')
                .querySelector('.swiper-button__next'),
              prevEl: swEl
                .closest('.meal-builder-main-grouping')
                .querySelector('.swiper-button__prev')
            },
            breakpoints: {
              740: {
                slidesPerView: 3.05,
                navigation: {
                  enabled: true
                }
              },
              1024: {
                slidesPerView: 2.05,
                navigation: {
                  enabled: true
                }
              },
              1180: {
                slidesPerView: 3.05,
                navigation: {
                  enabled: true
                }
              }
            }
          });
        };
        const destroySwiper = () => {
          if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
          }
        };
        // const mql = window.matchMedia('(min-width: 550px)');
        const mql = window.matchMedia('(min-width: 0px)');
        const handleResize = e => {
          if (e.matches) {
            if (!swiper) initSwiper();
          } else {
            destroySwiper();
          }
        };
        handleResize(mql);
        mql.addEventListener('change', handleResize);
      }

      // Wire +/− and inputs + header price
      wireQuantity(host);
    }

    // Wait for data, then render
    (async () => {
      if (dataReadyPromise) {
        try {
          await dataReadyPromise;
        } catch (_) {}
      }
      renderAddOns();
    })();

    MB._addonsWired = true;
  }

  // =========================
  // Bundle payload builder (bundleProductData + selections per week + add_ons)
  // =========================
  function installBundlePayloadBuilder() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._bundleBuilderWired) return;

    const strip = v => (v == null ? null : String(v));

    function pickVariantForDays(bp, days) {
      if (!bp) return null;
      const byMap = bp.dayVariantMap?.[days];
      if (byMap) return bp.variants.find(v => v.id === byMap) || null;

      return bp.variants?.[0] || null;
    }

    function getBundleProductData() {
      const bp = window.PRESS_MEAL_PLAN?.bundleProduct || null;
      const days = toInt(MB?.state?.days, 5);
      const variant = pickVariantForDays(bp, days);

      // Prefer variant-level selling plan ids; fallback to product-level
      const sellingPlanId =
        (variant?.sellingPlanIds && variant.sellingPlanIds[0]) ||
        (bp?.sellingPlanIds && bp.sellingPlanIds[0]) ||
        null;

      return {
        variantId: strip(variant?.id),
        productId: strip(bp?.productId),
        sellingPlan: sellingPlanId ? strip(sellingPlanId) : null
      };
    }

    function selectionsFromData(data) {
      const out = [];
      (data?.groupings || []).forEach(g => {
        (g.entries || []).forEach(e => {
          const qty = toInt(e.initialQuantity, 0);
          const pv = e.meal?.productVariant || null;
          if (qty > 0 && pv?.id) {
            out.push({
              collectionId:
                g.collectionId || pv.collectionId || ''
                  ? String(g.collectionId || pv.collectionId || '')
                  : '',
              externalProductId: String(pv.productId || ''),
              externalVariantId: String(pv.id || ''),
              quantity: qty
            });
          }
        });
      });
      return out;
    }

    function addOnsFromDOM() {
      const host = document.querySelector('.meal-builder-main__add-ons-section');
      if (!host) return [];
      const bp = window.PRESS_MEAL_PLAN?.bundleProduct || null;
      const productLevelSP = bp?.sellingPlanIds?.[0] || null;

      const out = [];
      host
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          if (qty <= 0) return;

          const mh = card.dataset.mealHandle;
          const meal = window.PRESS_MEAL_PLAN?.meals?.[mh];
          const pv = meal?.productVariant || null;
          const sp = (pv?.sellingPlanIds && pv.sellingPlanIds[0]) || productLevelSP || null;

          out.push({
            collectionId: strip(card.dataset.collectionId || pv?.collectionId || ''),
            externalProductId: strip(card.dataset.productId || pv?.productId || ''),
            externalVariantId: strip(card.dataset.variantId || pv?.id || ''),
            sellingPlan: sp ? strip(sp) : null,
            quantity: qty
          });
        });
      return out;
    }

    function selectionsForWeek(week) {
      const MB = (window.MealBuilder = window.MealBuilder || {});
      MB._cacheByPreset = MB._cacheByPreset || {};

      const preset = {
        week,
        diet: MB.state?.diet || 'all-meals',
        days: MB.state?.days || 5
      };
      const key = presetKey(preset);

      const cached = MB._cacheByPreset[key];
      if (cached) {
        return selectionsFromData(cached);
      }

      const sameWeek = week === (MB.state?.week || 'A');
      const base = sameWeek && MB._lastData ? MB._lastData : MB.getData(preset);

      return selectionsFromData(base);
    }

    MB.getBundleProductData = getBundleProductData;
    MB.getSelectionsForWeek = selectionsForWeek;
    MB.getAddOns = addOnsFromDOM;

    MB.buildBundlePayload = function buildBundlePayload() {
      const bpd = getBundleProductData();

      const bundleA = {
        externalVariantId: bpd.variantId,
        externalProductId: bpd.productId,
        selections: selectionsForWeek('A')
      };
      const bundleB = {
        externalVariantId: bpd.variantId,
        externalProductId: bpd.productId,
        selections: selectionsForWeek('B')
      };

      return {
        bundleProductData: bpd, // { variantId, productId, sellingPlan }
        weekA: { bundle: bundleA },
        weekB: { bundle: bundleB },
        add_ons: addOnsFromDOM()
      };
    };

    MB._bundleBuilderWired = true;
  }

  // ---- Cart rendering helpers (no <product-form> present) ----

  // Decide which sections to request and where to inject them
  function getCartSectionsToRender() {
    const list = [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-icon-bubble', selector: '.thb-item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart', section: 'main-cart-items', selector: '.thb-cart-form' }
    ];

    const seen = new Set();
    return list.filter(s => (seen.has(s.section) ? false : (seen.add(s.section), true)));
  }

  // Parse section HTML and inject into DOM
  function injectCartSections(parsedState) {
    const mapping = parsedState?.sections || {};
    const sections = getCartSectionsToRender();

    sections.forEach(({ id, section, selector }) => {
      const html = mapping[section];
      if (typeof html !== 'string' || !html.trim()) return;

      const container = document.getElementById(id);
      if (!container) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector(selector) || doc.body;
      const target = container.querySelector(selector) || container;

      if (source && target) {
        target.innerHTML = source.innerHTML;
      }
    });

    const drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      document.body.classList.add('open-cc', 'open-cart');
      drawer.classList.add('active');
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (_) {}
  }

  // ---- FRESH cart sections via GET (no cache) ----
  async function refreshCartSectionsViaGET(retry = 1) {
    const sections = getCartSectionsToRender()
      .map(s => s.section)
      .join(',');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}?sections=${encodeURIComponent(sections)}&t=${Date.now()}`;

    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    });

    const json = await res.json().catch(() => ({}));
    injectCartSections({ sections: json });

    const countEl = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (retry > 0 && countEl && String(countEl.textContent || '').trim() === '0') {
      await new Promise(r => setTimeout(r, 150));
      return refreshCartSectionsViaGET(retry - 1);
    }
  }

  // ---- Recharge + ATC handler for Meal Builder ----
  function installRechargeCartHandler_NoProductForm() {
    const BTNs = document.querySelectorAll('.meal-builder-order__btn');
    if (!BTNs.length || installRechargeCartHandler_NoProductForm._wired) return;
    installRechargeCartHandler_NoProductForm._wired = true;
    BTNs.forEach(BTN => {
      BTN.addEventListener('click', async e => {
        e.preventDefault();
        const MB = window.MealBuilder || {};
        if (!MB.buildBundlePayload) return;

        BTN.classList.add('loading');
        BTN.setAttribute('aria-disabled', 'true');

        let savePresetFailed = false;
        let bundleIdFailed = false;

        try {
          const payload = MB.buildBundlePayload();
          const bpd = payload.bundleProductData || {};
          const weekKey = `week${MB.state?.week || 'A'}`;
          const selections = payload[weekKey]?.bundle?.selections || [];

          // === Build two Recharge bundles (A and B) and get two separate rbIds ===
          if (!window.recharge?.bundle?.getBundleId) {
            console.warn('[MealBuilder] recharge.bundle.getBundleId not available');
          }

          const selectionsA = payload.weekA?.bundle?.selections || [];
          const selectionsB = payload.weekB?.bundle?.selections || [];

          const rbBundleA = {
            externalVariantId: String(bpd.variantId || ''),
            externalProductId: String(bpd.productId || ''),
            selections: selectionsA
          };
          const rbBundleB = {
            externalVariantId: String(bpd.variantId || ''),
            externalProductId: String(bpd.productId || ''),
            selections: selectionsB
          };

          let rbIdA = null;
          let rbIdB = null;
          let presetId = null;

          try {
            rbIdA =
              window.recharge?.bundle?.getBundleId && selectionsA.length
                ? await window.recharge.bundle.getBundleId(rbBundleA)
                : null;
          } catch (err) {
            console.warn('[MealBuilder] getBundleId(A) failed:', err);
            if (selectionsA.length) bundleIdFailed = true;
          }

          if (selectionsA.length && !rbIdA) {
            bundleIdFailed = true;
          }

          try {
            rbIdB =
              window.recharge?.bundle?.getBundleId && selectionsB.length
                ? await window.recharge.bundle.getBundleId(rbBundleB)
                : null;
          } catch (err) {
            console.warn('[MealBuilder] getBundleId(B) failed:', err);
            if (selectionsB.length) bundleIdFailed = true;
          }
          if (selectionsB.length && !rbIdB) {
            bundleIdFailed = true;
          }

          const rbIdForParent = rbIdA;

          if (bundleIdFailed) {
            window.MealBuilder?.Notice?.showPresetError?.();
            return;
          }

          // === Save preset (await response) BEFORE /cart/add ===
          try {
            // Helper: map selection to API product object
            const mapToApiProduct = (sel, sellingPlanId, rbIdForThisWeek) => {
              const item = {
                product_id: String(sel.externalProductId || ''),
                variant_id: String(sel.externalVariantId || ''),
                quantity: Number(sel.quantity || 0),
                collection_source: 'shopify'
              };
              if (sel.collectionId) item.collection_id = String(sel.collectionId);
              if (sellingPlanId) item.selling_plan_id = String(sellingPlanId);
              if (rbIdForThisWeek)
                item.properties = { recharge_bundle_id: String(rbIdForThisWeek) };
              return item;
            };

            const body = {
              week_a: { bundle: selectionsA.map(s => mapToApiProduct(s, bpd.sellingPlan, rbIdA)) },
              week_b: { bundle: selectionsB.map(s => mapToApiProduct(s, bpd.sellingPlan, rbIdB)) },

              add_ons: (payload.add_ons || []).map(a => ({
                product_id: String(a.externalProductId || ''),
                variant_id: String(a.externalVariantId || ''),
                quantity: Number(a.quantity || 0),
                collection_source: 'shopify',
                ...(a.collectionId ? { collection_id: String(a.collectionId) } : {}),
                ...(a.sellingPlan || bpd.sellingPlan
                  ? { selling_plan_id: String(a.sellingPlan || bpd.sellingPlan) }
                  : {})
              }))
            };

            const resp = await fetch('https://api.press-healthfoods.com/api/save-preset', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            });

            if (!resp.ok) {
              console.warn('[MealBuilder] save-preset responded non-OK:', resp.status);
              savePresetFailed = true;
            } else {
              const json = await resp.json().catch(() => null);
              const candidate =
                json?.preset_id ?? json?.presetId ?? json?.id ?? json?.data?.preset_id ?? null;

              if (candidate) {
                presetId = String(candidate);
                log('[MealBuilder] save-preset preset_id =', presetId);
              } else {
                console.warn('[MealBuilder] save-preset: no preset_id in response', json);
                savePresetFailed = true;
              }
            }
          } catch (err) {
            console.warn('[MealBuilder] save-preset failed:', err);
            savePresetFailed = true;
          }
          // === /save-preset ===

          if (savePresetFailed) {
            window.MealBuilder?.Notice?.showPresetError?.();
            return;
          }

          // 3) Compose Shopify /cart/add payload (bundle parent + add-ons as separate lines)
          const items = [];

          // Add-ons
          (payload.add_ons || []).forEach(a => {
            if (!a?.externalVariantId || !a?.quantity) return;

            const line = {
              id: String(a.externalVariantId),
              quantity: Number(a.quantity)
            };

            if (a.sellingPlan) line.selling_plan = String(a.sellingPlan);
            else if (bpd.sellingPlan) line.selling_plan = String(bpd.sellingPlan);

            items.push(line);
          });

          const parentLine = {
            id: String(bpd.variantId),
            quantity: 1
          };

          const parentProps = {};
          if (rbIdForParent) parentProps._rb_id = String(rbIdForParent);
          if (presetId) parentProps._preset_id = String(presetId);
          if (Object.keys(parentProps).length) parentLine.properties = parentProps;

          if (bpd.sellingPlan) parentLine.selling_plan = String(bpd.sellingPlan);
          items.push(parentLine);

          // 4) POST /cart/add
          const sectionsWanted = getCartSectionsToRender().map(s => s.section);

          const fd = new FormData();
          items.forEach((line, i) => {
            fd.append(`items[${i}][id]`, line.id);
            fd.append(`items[${i}][quantity]`, String(line.quantity));
            if (line.selling_plan) {
              fd.append(`items[${i}][selling_plan]`, line.selling_plan);
            }
            if (line.properties) {
              Object.entries(line.properties).forEach(([k, v]) => {
                fd.append(`items[${i}][properties][${k}]`, String(v));
              });
            }
          });
          fd.append('sections', sectionsWanted.join(','));
          fd.append('sections_url', window.location.pathname);

          const addUrl = window.theme?.routes?.cart_add_url || '/cart/add';
          const res = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: fd,
            credentials: 'same-origin'
          });

          await processCartAddResponse(res);
        } catch (err) {
          console.error('[MealBuilder] Add to cart failed', err);
          try {
            await refreshCartSectionsViaGET();
          } catch (_) {}
        } finally {
          BTN.classList.remove('loading');
          BTN.removeAttribute('aria-disabled');
        }
      });
    });
  }

  // =========================
  // Grouping popup binder (fills popup header + list before opening)
  // =========================
  function installGroupingPopupBinder() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._groupingPopupWired) return;

    // Build one product card HTML for grouping popup (no swiper wrapper + extra class)
    function buildEntryCardHTML(entry, groupCollectionId) {
      const m = entry.meal || {};
      const pv = m.productVariant || null;

      const displayName = m.displayName || m.handle || entry.handle || '';
      const titleId = `mb-card-title-${idify(`popup-${m.handle || entry.handle || displayName}`)}`;
      const initialQty = toInt(entry.initialQuantity, 0);
      const maxAllowed = toInt(entry.maximumAllowed, 0);
      const image = pv?.image || null;
      const imageSrc = image?.url || '';
      const imageAlt = displayName;

      const dietaryFirst =
        Array.isArray(m.dietaryType) && m.dietaryType.length ? String(m.dietaryType[0]) : '';
      const dietaryIcon = dietaryIconSrc(dietaryFirst);
      const dietaryTooltipContentText = dietaryTooltipContent(dietaryFirst);

      const highlights = Array.isArray(m.highlights) ? m.highlights.slice(0, 2) : [];
      const calories = toInt(m.nutrition?.calories ?? m.calories, null);
      const carbs = toNum(m.nutrition?.carbohydrates ?? m.carbohydrates, null);
      const protein = toNum(m.nutrition?.protein ?? m.protein, null);
      const shortDescHtml = richTextToHTML(m.shortDescription || '');

      const dataAttrs = `
              data-initial-quantity="${esc(initialQty)}"
              data-maximum-allowed="${esc(maxAllowed)}"
              data-available-for-sale="${esc(pv ? pv.availableForSale : '')}"
              data-collection-id="${esc(groupCollectionId || pv?.collectionId || '')}"
              data-variant-id="${esc(pv?.id || '')}"
              data-product-id="${esc(pv?.productId || '')}"
            `;

      const calHtml =
        calories != null && calories !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-calories">${esc(calories)} cal</span>`
          : '';
      const carbsHtml =
        carbs != null && carbs !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-carbs">${esc(carbs)}g carbs</span>`
          : '';
      const proteinHtml =
        protein != null && protein !== ''
          ? `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-protein">${esc(protein)}g protein</span>`
          : '';
      const highlightsHtml = highlights
        .map(
          h =>
            `<span class="meal-builder-main-product-card__info-nutrition-label meal-builder-main-product-card__info-nutrition-highlight">${esc(h)}</span>`
        )
        .join('');

      const dietaryHtml = dietaryIcon
        ? `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false" data-tippy-content="${dietaryTooltipContentText}" data-tippy-placement="bottom" data-tippy-allowhtml="true">
                   <img src="${dietaryIcon}" alt="${esc(dietaryFirst)}" loading="lazy">
                 </div>`
        : `<div class="meal-builder-main-product-card__dietary" aria-hidden="true" focusable="false"></div>`;
      return `
          <article class="meal-builder-main-product-card grouping-popup"
                   role="group"
                   aria-labelledby="${esc(titleId)}"
                   data-entry-handle="${esc(entry.handle)}"
                   ${dataAttrs}
          >
            <div class="meal-builder-main-product-card__image">
              <div class="meal-builder-main-product-card__quantity-selected"
                   aria-live="polite"
                   aria-label="Selected quantity: ${esc(initialQty)}">
                <span class="meal-builder-main-product-card__quantity-selected-label">x${esc(initialQty)}</span>
              </div>

              <div class="product-info-popup-trigger meal-builder-main-product-card__image-link"
                   data-meal-handle="${esc(m.handle || '')}">
                <img
                  src="${esc(imageSrc)}"
                  alt="${esc(imageAlt)}"
                  class="meal-builder-main-product-card__image-img"
                  loading="lazy"
                >
              </div>

              ${dietaryHtml}

              <button
                onclick="customMealShowPopup()"
                class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--desktop product-info-popup-trigger"
                type="button"
                aria-label="More information"
                data-meal-handle="${esc(m.handle || '')}"
              >
                <img src="${infoTooltipIconUrl}" alt="" loading="lazy" aria-hidden="true">
              </button>

              <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--mobile">
                <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="visually-hidden">Qty</label>
                <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-mobile" class="meal-builder-main-product-card__quantity-input" value="${esc(initialQty)}" />
                <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
              </div>
            </div>

            <div class="meal-builder-main-product-card__info">
              <header class="meal-builder-main-product-card__info-header">
                <div class="product-info-popup-trigger" data-meal-handle="${esc(m.handle || '')}">
                  <h3 id="${esc(titleId)}" class="meal-builder-main-product-card__info-title">
                    ${esc(displayName)}
                  </h3>
                </div>

                <button
                  onclick="customMealShowPopup()"
                  class="meal-builder-main-product-card__info-button meal-builder-main-product-card__info-button--mobile product-info-popup-trigger"
                  type="button"
                  aria-label="More information"
                  data-meal-handle="${esc(m.handle || '')}"
                >
                  <img src="${infoTooltipIconUrl}" alt="More information" aria-hidden="true">
                </button>
              </header>

              <div class="meal-builder-main-product-card__info-nutrition">
                ${calHtml}${carbsHtml}${proteinHtml}${highlightsHtml}
              </div>

              <div class="meal-builder-main-product-card__info-short-description">
                ${shortDescHtml}
              </div>

              <div class="meal-builder-main-product-card__quantity meal-builder-main-product-card__quantity--desktop">
                <button type="button" class="meal-builder-main-product-card__quantity-toggle decrease-quantity-btn" aria-label="Decrease quantity">-</button>
                <label for="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="visually-hidden">Qty</label>
                <input type="text"id="meal-builder-main-product-card__quantity-${esc(pv?.productId || '')}-desktop" class="meal-builder-main-product-card__quantity-input" value="${esc(initialQty)}" />
                <button type="button" class="meal-builder-main-product-card__quantity-toggle increase-quantity-btn" aria-label="Increase quantity">+</button>
              </div>
            </div>
          </article>
        `;
    }

    // Fill popup by grouping handle
    function fillGroupingPopupByHandle(handle) {
      const data = MB._lastData;
      if (!data) return;

      const group = (data.groupings || []).find(g => g.handle === handle);
      if (!group) return;

      const popup = document.querySelector('[data-custom-meal-builder-popup-grouping]');
      if (!popup) return;

      // 1) Header title = group.name (fallback handle)
      const headerEl = popup.querySelector('.meal-builder-main-grouping-popup__header-title');
      if (headerEl) headerEl.textContent = group.name || group.handle || '';

      // 2) save btn text update
      const saveBtnEl = popup.querySelector(
        '.meal-builder-main-grouping-popup__footer-buttons-save'
      );
      if (saveBtnEl)
        saveBtnEl.textContent = `Save ${group.name} Options` || 'Save Selected Options';

      // 3) List = ALL entries, but first those with initialQty > 0
      const listEl = popup.querySelector('.meal-builder-main-grouping-popup__list');
      if (listEl) {
        const sorted = [...(group.entries || [])].sort((a, b) => {
          const aPos = toInt(a.initialQuantity, 0) > 0 ? 1 : 0;
          const bPos = toInt(b.initialQuantity, 0) > 0 ? 1 : 0;
          return bPos - aPos; // positives first
        });
        listEl.innerHTML = sorted
          .map(e => buildEntryCardHTML(e, group.collectionId || null))
          .join('');

        // Snapshot initial quantities for dirty-check (per open)
        popup._mbInitialValues = {};
        (group.entries || []).forEach(e => {
          popup._mbInitialValues[e.handle] = toInt(e.initialQuantity, 0);
        });
        popup._mbDirty = false; // no changes at open
        popup.dataset.groupHandle = group.handle || '';

        // Init tippy on ALL entries
        document.querySelectorAll('.meal-builder-main-product-card__dietary').forEach(EL => {
          if (EL) {
            tippy(EL, {
              theme: 'press',
              animation: 'shift-toward'
            });
          }
        });

        // Detach previous listeners for this popup (fixes "increment grows each open")
        if (popup._mbGroupCtl) {
          try {
            popup._mbGroupCtl.abort();
          } catch (_) {}
        }
        popup._mbGroupCtl = new AbortController();

        // (Re)wire quantity logic for this open
        wireGroupingQuantity(popup, group, popup._mbGroupCtl.signal);
      }
    }

    // Wires +/−, input editing, summary and Save button inside the grouping popup
    function wireGroupingQuantity(popup, group, signal) {
      const MB = (window.MealBuilder = window.MealBuilder || {});

      // Use current days from state (fallback to last data / default 5)
      const baseTargetDays = toInt(MB?.state?.days ?? MB?._lastData?.days, 5);
      const isDoubleLimitGroup = String(group?.collectionId || '') === '676975346050';
      const targetDays = baseTargetDays; // оставим для читаемости
      const groupLimit = isDoubleLimitGroup ? baseTargetDays * 2 : baseTargetDays;

      const listEl = popup.querySelector('.meal-builder-main-grouping-popup__list');
      if (!listEl) return;

      // -------- helpers (pure) --------

      // Clamp numeric value by 0 and "maximum allowed" (if > 0)
      const clampByMax = (card, val) => {
        const maxAllowed = toInt(card.dataset.maximumAllowed, 0);
        let v = Math.max(0, toInt(val, 0));
        if (maxAllowed > 0) v = Math.min(v, maxAllowed);
        return v;
      };

      // Apply value to both inputs and the floating "xN" bubble of a card
      const setCardValue = (card, val) => {
        const v = clampByMax(card, val);
        card
          .querySelectorAll('.meal-builder-main-product-card__quantity-input')
          .forEach(inp => (inp.value = v));
        const bubble = card.querySelector(
          '.meal-builder-main-product-card__quantity-selected-label'
        );
        if (bubble) bubble.textContent = `x${v}`;
        card.classList.toggle('has-quantity', v > 0);
        return v;
      };

      // Read value from one of the inputs in a card (treated as number)
      const getCardValue = card =>
        toInt(card.querySelector('.meal-builder-main-product-card__quantity-input')?.value, 0);

      // Recompute "dirty" flag by comparing current values vs. snapshot from popup._mbInitialValues
      function recomputeDirtyFlag() {
        const init = popup._mbInitialValues || {};
        let dirty = false;

        listEl.querySelectorAll('.meal-builder-main-product-card.grouping-popup').forEach(card => {
          const eh = card.dataset.entryHandle;
          const cur = getCardValue(card);
          const initVal = toInt(init[eh], 0);
          if (cur !== initVal) dirty = true;
        });

        popup._mbDirty = dirty;

        // Optional: reflect in DOM for debugging (can be inspected in DevTools)
        if (dirty) popup.setAttribute('data-dirty', 'true');
        else popup.removeAttribute('data-dirty');
      }

      // -------- availability pass --------

      listEl.querySelectorAll('.meal-builder-main-product-card.grouping-popup').forEach(card => {
        const available = String(card.dataset.availableForSale || '').toLowerCase() !== 'false';
        const qtyBlocks = card.querySelectorAll('.meal-builder-main-product-card__quantity');
        const inputs = card.querySelectorAll('.meal-builder-main-product-card__quantity-input');
        const decs = card.querySelectorAll('.decrease-quantity-btn');
        const incs = card.querySelectorAll('.increase-quantity-btn');

        if (!available) {
          // Not available: force 0 and disable all quantity controls
          setCardValue(card, 0);
          qtyBlocks.forEach(q => q.setAttribute('aria-disabled', 'true'));
          inputs.forEach(i => {
            i.value = 0;
            i.disabled = true;
          });
          decs.forEach(b => (b.disabled = true));
          incs.forEach(b => (b.disabled = true));
          card.classList.add('is-unavailable');
        } else {
          // Ensure initial values respect "maximum allowed"
          setCardValue(card, getCardValue(card));
        }
      });

      // -------- summary UI refs --------

      // Can be multiple "selected-number" and "selected-choose" in the template: update all
      const chooseEls = popup.querySelectorAll(
        '.meal-builder-main-grouping-popup__selected-choose'
      );
      const numbersEls = popup.querySelectorAll(
        '.meal-builder-main-grouping-popup__selected-number'
      );
      const saveBtn = popup.querySelector('.meal-builder-main-grouping-popup__footer-buttons-save');

      // Recalculate total, update "X/Y", helper text and Save enabled state
      function updateSummaryUI() {
        const cards = [
          ...listEl.querySelectorAll('.meal-builder-main-product-card.grouping-popup')
        ];
        const sum = cards.reduce((acc, card) => acc + getCardValue(card), 0);

        // 4) "X/Y" (sum / DAYS_MAP)
        numbersEls.forEach(el => {
          if (el) el.textContent = `${sum}/${groupLimit}`;
        });
        const delta = groupLimit - sum;

        // 1–2) Choose/Remove text + Save button
        if (delta === 0) {
          // Exactly matched: hide helper, enable Save
          chooseEls.forEach(el => hideEl(el));
          if (saveBtn) saveBtn.disabled = false;
        } else {
          // Not matched: show helper with correct number and disable Save
          const need = Math.abs(delta);
          const text = delta > 0 ? `Choose ${need} More to Save` : `Remove ${need} More to Save`;
          chooseEls.forEach(el => {
            if (el) {
              el.textContent = text;
              showEl(el);
            }
          });
          if (saveBtn) saveBtn.disabled = true;
        }
      }

      // -------- events (all bound with `signal` so they are auto-removed on next open) --------

      // Clicks on + / − buttons (event delegation)
      listEl.addEventListener(
        'click',
        e => {
          const inc = e.target.closest('.increase-quantity-btn');
          const dec = e.target.closest('.decrease-quantity-btn');
          if (!inc && !dec) return;

          const card = e.target.closest('.meal-builder-main-product-card.grouping-popup');
          if (!card || String(card.dataset.availableForSale || '').toLowerCase() === 'false')
            return;

          const current = getCardValue(card);
          const next = clampByMax(card, current + (inc ? 1 : -1));
          setCardValue(card, next);
          updateSummaryUI();
          emitPreview();
          recomputeDirtyFlag();
        },
        { capture: true, signal }
      );

      // Manual input editing (change/input)
      const onValueEdit = e => {
        if (!e.target.matches('.meal-builder-main-product-card__quantity-input')) return;
        const card = e.target.closest('.meal-builder-main-product-card.grouping-popup');
        if (!card) return;
        setCardValue(card, e.target.value);
        updateSummaryUI();
        emitPreview();
        recomputeDirtyFlag();
      };
      listEl.addEventListener('change', onValueEdit, { capture: true, signal });
      listEl.addEventListener('input', onValueEdit, { capture: true, signal });

      // Initial summary refresh
      updateSummaryUI();
      recomputeDirtyFlag();

      // Save button: apply chosen quantities back to MB._lastData and trigger rerender
      popup.addEventListener(
        'click',
        e => {
          const btn = e.target.closest('.meal-builder-main-grouping-popup__footer-buttons-save');
          if (!btn || btn.disabled) return;

          // Collect quantities by entry handle
          const cards = [
            ...listEl.querySelectorAll('.meal-builder-main-product-card.grouping-popup')
          ];
          const valuesByEntry = {};
          let sum = 0;
          cards.forEach(card => {
            const handle = card.dataset.entryHandle; // requires data-entry-handle in card
            const val = getCardValue(card);
            valuesByEntry[handle] = val;
            sum += val;
          });

          // Guard: only apply if total perfectly matches DAYS_MAP
          if (sum !== groupLimit) return;

          const data = MB._lastData;
          if (!data) return;

          // Replace quantities inside the target group
          const targetGroup = (data.groupings || []).find(g => g.handle === group.handle);
          if (!targetGroup) return;

          targetGroup.entries = (targetGroup.entries || []).map(e => ({
            ...e,
            initialQuantity: toInt(valuesByEntry[e.handle], 0)
          }));

          // Update per-preset cache and lastData BEFORE notifying listeners,
          // so all synchronous 'mealbuilder:data' handlers see the new snapshot.
          MB._cacheByPreset = MB._cacheByPreset || {};
          MB._cacheByPreset[presetKey(MB.state)] = deepClone(data);
          MB._lastData = data;

          // Now emit 'mealbuilder:data' -> renderer & order summary will re-render using the updated cache
          const section = document.getElementById(SECTION_ID);
          if (section) {
            section.dispatchEvent(
              new CustomEvent('mealbuilder:data', {
                detail: { state: { ...(MB.state || {}) }, data }
              })
            );
          }

          // Update per-preset cache with the just-saved selection for this (diet,days,week)
          MB._cacheByPreset = MB._cacheByPreset || {};
          MB._cacheByPreset[presetKey(MB.state)] = deepClone(data);

          // Update snapshot to the just-saved values and clear dirty flag
          popup._mbInitialValues = { ...valuesByEntry };
          popup._mbDirty = false;
          popup.removeAttribute('data-dirty');

          // Close the popup after saving
          closeCustomMealPopup();
        },
        { capture: true, signal }
      );

      function emitPreview() {
        const cards = [
          ...listEl.querySelectorAll('.meal-builder-main-product-card.grouping-popup')
        ];
        const valuesByEntry = {};
        cards.forEach(card => {
          const eh = card.dataset.entryHandle;
          valuesByEntry[eh] = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
        });
        const section = document.getElementById(SECTION_ID);
        section?.dispatchEvent(
          new CustomEvent('mealbuilder:grouping-preview', {
            detail: {
              week: window.MealBuilder?.state?.week || 'A',
              groupHandle: group.handle,
              valuesByEntry
            }
          })
        );
      }
    }

    // Capture-phase delegate so it runs BEFORE inline onclick="customMealShowPopup('grouping')"
    document.addEventListener(
      'click',
      e => {
        const btn = e.target.closest('.meal-builder-main-grouping__heading-btn');
        if (!btn) return;

        const wrapper = btn.closest('.meal-builder-main-grouping');
        const handle = wrapper?.dataset.grouping;
        if (!handle) return;

        // Fill popup right before it opens
        fillGroupingPopupByHandle(handle);
      },
      { capture: true }
    );

    MB._groupingPopupWired = true;
  }

  // =========================
  // Product popup binder (uses existing show/hide popup functions)
  // =========================
  function installProductPopupBinder() {
    if (window.MealBuilder && window.MealBuilder._productPopupWired) return;

    // Fill product popup with meal + chef data
    function fillProductPopup(meal, chef) {
      const popup = document.querySelector('[data-custom-meal-builder-popup-product-card]');
      if (!popup) return;

      // Title
      const title = meal.displayName || meal.handle || '';
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__header-title'),
        null,
        title
      );

      // Short description (rich text → HTML)
      setHTMLOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__short-description'),
        richTextToHTML(meal.shortDescription || '')
      );

      // Highlights (all)
      const hlWrap = popup.querySelector('.meal-builder-main-product-card-popup__highlights');
      if (hlWrap) {
        const hs = Array.isArray(meal.highlights) ? meal.highlights : [];
        if (hs.length) {
          hlWrap.innerHTML = hs
            .map(
              h =>
                `<span class="meal-builder-main-product-card-popup__highlights-label">${esc(h)}</span>`
            )
            .join('');
          showEl(hlWrap);
        } else {
          hideEl(hlWrap);
        }
      }

      // Main image + alt
      const imgWrap = popup.querySelector('.meal-builder-main-product-card-popup__image');
      const imgEl = imgWrap ? imgWrap.querySelector('img') : null;
      const pvImg = meal.productVariant?.image || null;
      if (imgEl && pvImg?.url) {
        imgEl.src = pvImg.url;
        imgEl.alt = title;
        showEl(imgWrap);
      } else if (imgWrap) {
        hideEl(imgWrap);
      }

      // Dietary icon by first dietaryType
      const dietWrap = popup.querySelector('.meal-builder-main-product-card-popup__image-dietary');
      if (dietWrap) {
        const first =
          Array.isArray(meal.dietaryType) && meal.dietaryType.length
            ? String(meal.dietaryType[0])
            : '';
        const icon = dietaryIconSrc(first);
        const dietImg = dietWrap.querySelector('img');
        const tooltipText = dietaryTooltipContent(first);
        if (icon && dietImg) {
          dietImg.src = icon;
          dietImg.alt = first;
          showEl(dietWrap);

          if (tooltipText && dietWrap?.hasAttribute('data-tippy-content')) {
            dietWrap.setAttribute('data-tippy-content', tooltipText);
            dietWrap._tippy?.setContent(tooltipText);
          }
        } else {
          hideEl(dietWrap);
        }
      }

      // Nutrition items (hide item if value missing)
      const calVal = toInt(meal.nutrition?.calories ?? meal.calories, null);
      const carbsVal = toNum(meal.nutrition?.carbohydrates ?? meal.carbohydrates, null);
      const proteinVal = toNum(meal.nutrition?.protein ?? meal.protein, null);
      const fatsVal = toNum(meal.nutrition?.fats ?? meal.fats, null);
      const portionVal = meal.nutrition?.portionSize ?? meal.portionSize ?? null;

      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__nutritional-item-kcal'),
        '.meal-builder-main-product-card-popup__nutritional-item-number',
        calVal ?? ''
      );
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__nutritional-item-carbs'),
        '.meal-builder-main-product-card-popup__nutritional-item-number',
        carbsVal != null ? `${carbsVal}g` : ''
      );
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__nutritional-item-protein'),
        '.meal-builder-main-product-card-popup__nutritional-item-number',
        proteinVal != null ? `${proteinVal}g` : ''
      );
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__nutritional-item-fats'),
        '.meal-builder-main-product-card-popup__nutritional-item-number',
        fatsVal != null ? `${fatsVal}g` : ''
      );
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__nutritional-item-portion'),
        '.meal-builder-main-product-card-popup__nutritional-item-number',
        portionVal || ''
      );

      // Ingredients
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__info-inner-ingredients'),
        '.meal-builder-main-product-card-popup__info-text',
        meal.ingredients || ''
      );

      // Allergens
      setTextOrHide(
        popup.querySelector('.meal-builder-main-product-card-popup__info-inner-allergens'),
        '.meal-builder-main-product-card-popup__info-text',
        meal.allergens || 'No known allergens'
      );

      // Chef section
      const chefSection = popup.querySelector('.meal-builder-main-product-card-popup__chef');
      const chefSectionWrapper = popup.querySelector(
        '.meal-builder-main-product-card-popup__chef-wrapper'
      );
      if (meal.chef && chef && chef.name && meal.chefsNotes) {
        showEl(chefSection);
        showEl(chefSectionWrapper);

        const chefLink = chefSection.querySelector(
          '.meal-builder-main-product-card-popup__chef-container'
        );
        const chefImg = chefLink ? chefLink.querySelector('img') : null;
        const chefNameEl = chefSection.querySelector(
          '.meal-builder-main-product-card-popup__chef-name'
        );
        const chefNotesEl = chefSection.querySelector(
          '.meal-builder-main-product-card-popup__chef-notes'
        );

        // Link
        if (chefLink) {
          if (chef.link) {
            chefLink.href = chef.link;
            showEl(chefLink);
          } else {
            chefLink.removeAttribute('href');
            showEl(chefLink);
          }
        }

        // Chef image + alt
        if (chefImg && chef.image?.url) {
          chefImg.src = chef.image.url;
          chefImg.alt = chef.name;
          showEl(chefImg);
        } else if (chefImg) {
          hideEl(chefImg);
        }

        // Chef name
        setTextOrHide(chefNameEl, null, chef.name);

        // Chef's notes (rich text)
        setHTMLOrHide(chefNotesEl, richTextToHTML(chef.notes || meal.chefsNotes || ''));
      } else {
        hideEl(chefSection);
        hideEl(chefSectionWrapper);
      }
    }

    // Reset scroll position of the product popup to the very top on every open
    function resetProductPopupScroll() {
      // The scrollable container itself has overflow-y: auto
      const el =
        document.querySelector('.meal-builder-main-product-card-popup') ||
        document.querySelector('[data-custom-meal-builder-popup-product-card]');
      if (!el) return;

      // Reset immediately (covers "hidden → visible" without animation)
      el.scrollTop = 0;
      // Some browsers prefer scrollTo; keep behavior instant
      el.scrollTo?.({ top: 0, left: 0, behavior: 'auto' });

      // Also reset on the next frame in case layout changes after opening
      requestAnimationFrame(() => {
        try {
          el.scrollTop = 0;
          el.scrollTo?.({ top: 0, left: 0, behavior: 'auto' });
        } catch (_) {}
      });
    }

    // Open by meal handle: fill then show your product popup
    function openProductByHandle(handle) {
      const plan = window.PRESS_MEAL_PLAN || {};
      const meal = plan.meals?.[handle];
      if (!meal) {
        warn('[MealBuilder] meal not found for handle', handle);
        return;
      }
      const chef = meal.chef ? plan.chefs?.[meal.chef] : null;
      fillProductPopup(meal, chef);

      // Ensure scroll is at the top before showing (works even if still hidden)
      resetProductPopupScroll();

      // Use global function to show product popup
      if (typeof window.customMealShowPopup === 'function') {
        window.customMealShowPopup(); // no 'grouping' → product popup

        // Ensure scroll is at the top after it becomes visible/layouted
        requestAnimationFrame(() => resetProductPopupScroll());
      } else {
        // Fallback: still do one more reset on the next frame
        requestAnimationFrame(() => resetProductPopupScroll());
      }
    }

    // Delegate clicks from any info button (works with inline onclick too)
    document.addEventListener(
      'click',
      e => {
        const btn = e.target.closest('.product-info-popup-trigger');
        if (!btn) return;
        const handle = btn.dataset.mealHandle;
        if (!handle) return;
        e.preventDefault();
        openProductByHandle(handle);
      },
      { capture: true }
    );

    // Expose optional API / guard
    window.MealBuilder = window.MealBuilder || {};
    window.MealBuilder.openMealPopupByHandle = openProductByHandle;
    window.MealBuilder._productPopupWired = true;
  }

  // =========================
  // Order accordions (summary + totals)
  // =========================
  function installOrderAccordion() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._orderAccordionWired) return;

    const planAcc = document.querySelector('.meal-plan-order-accordion');
    const addonsAcc = document.querySelector('.add-ons-order-accordion');

    const subtotalEl = document.querySelector('.meal-builder-order__subtotal-value');
    const perDayEl = document.querySelector('.meal-builder-order__subtotal-price-per-day');
    const totalFirstEl = document.querySelector('.meal-builder-order__total-first-price');
    const totalSubEl = document.querySelector('.meal-builder-order__total-sub-price');

    // Simple content signatures to detect "did content actually change?"
    let prevPlanSig = '';
    let prevAddonsSig = '';

    const pokeIfOpen = (accEl, changed) => {
      // Only recalc if this instance is open and content actually changed
      if (!accEl || !changed || !accEl.classList.contains('is-open')) return;

      const content = accEl.querySelector('[data-accordion-content]');
      if (!content) return;

      // Force reflow, then set maxHeight to the new scrollHeight
      // This keeps the accordion open and fits updated HTML
      void content.offsetHeight; // force reflow
      content.style.maxHeight = content.scrollHeight + 'px';
    };

    // ---- helpers ----
    const getBundleVariantForDays = days => {
      const bp = window.PRESS_MEAL_PLAN?.bundleProduct;
      if (!bp) return null;
      const mappedId = bp.dayVariantMap?.[days];
      let v = mappedId ? (bp.variants || []).find(x => String(x.id) === String(mappedId)) : null;
      if (!v) v = (bp.variants || [])[0] || null;
      return v;
    };

    const getBasePrice = () => {
      const days = toInt(MB?.state?.days, 5);
      const v = getBundleVariantForDays(days);
      return {
        amount: Number(v?.price?.amount || 0),
        currency: v?.price?.currencyCode || 'GBP'
      };
    };

    const sumAddOns = () => {
      const host = document.querySelector('.meal-builder-main__add-ons-section');
      if (!host) return 0;
      let total = 0;
      host
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          if (qty <= 0) return;
          const unit = toNum(card.dataset.unitPrice, 0) || 0;
          total += qty * unit;
        });
      return total;
    };

    const selectedAddOnsList = () => {
      const host = document.querySelector('.meal-builder-main__add-ons-section');
      if (!host) return [];
      const plan = window.PRESS_MEAL_PLAN || {};
      const out = [];
      host
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          if (qty <= 0) return;
          const mh = card.dataset.mealHandle;
          const meal = plan.meals?.[mh];
          const title = meal?.displayName || meal?.handle || '';
          out.push({ qty, title });
        });
      return out;
    };

    const weekDataPreferCache = week => {
      // Use cache snapshot for the (diet|days|week) if user has saved something,
      // otherwise recompute fresh from PRESS_MEAL_PLAN.
      const preset = {
        week,
        diet: window.MealBuilder?.state?.diet || 'all-meals',
        days: window.MealBuilder?.state?.days || 5
      };
      const key = presetKey(preset);
      const cache = MB._cacheByPreset?.[key];
      return cache ? deepClone(cache) : MB.getData(preset);
    };

    const buildWeekHTML = (label, data) => {
      const groupsHtml = (data?.groupings || [])
        .map(g => {
          const itemsHtml = (g.entries || [])
            .filter(e => toInt(e.initialQuantity, 0) > 0)
            .map(e => {
              const qty = toInt(e.initialQuantity, 0);
              const name = e.meal?.displayName || e.meal?.handle || e.handle || '';
              return `<li><span>${esc(qty)}x</span> <span>${esc(name)}</span></li>`;
            })
            .join('');
          if (!itemsHtml) return '';
          const gName = g.name || g.handle || '';
          return `<li>
        <span class="meal-builder-order__meal-type">${esc(gName)}:</span>
        <ul class="meal-builder-order__meal-items" role="list">
          ${itemsHtml}
        </ul>
      </li>`;
        })
        .filter(Boolean)
        .join('');

      if (!groupsHtml) return '';
      return `<li>
      <span class="meal-builder-order__week-label">Week ${esc(label)}:</span>
      <ul class="meal-builder-order__meal-list" role="list">
        ${groupsHtml}
      </ul>
    </li>`;
    };

    // Main render — called after any "authoritative" change (mealbuilder:data, addons-changed)
    function render() {
      // --- MEAL PLAN ACCORDION ---
      if (planAcc) {
        const days = toInt(MB?.state?.days, 5);
        const captionText = `${days} days/week`;
        const base = getBasePrice();
        const priceText = formatMoney(base.amount, base.currency);

        const dataA = weekDataPreferCache('A');
        const dataB = weekDataPreferCache('B');

        const htmlA = buildWeekHTML('1', dataA);
        const htmlB = buildWeekHTML('2', dataB);
        const contentHtml = `${htmlA}${htmlB}`;

        const newSig = [captionText, priceText, contentHtml].join('|');

        const captionEl = planAcc.querySelector('.meal-builder-order__accordion-plan-caption');
        const priceEl = planAcc.querySelector('.meal-builder-order__accordion-price');
        const contentEl = planAcc.querySelector('.meal-builder-order__accordion-content');

        if (captionEl) captionEl.textContent = captionText;
        if (priceEl) priceEl.textContent = priceText;
        if (contentEl) contentEl.innerHTML = contentHtml || '<!-- empty -->';

        // If content changed and accordion is open — click trigger to re-measure height
        pokeIfOpen(planAcc, newSig !== prevPlanSig);
        prevPlanSig = newSig;
      }

      // --- ADD-ONS ACCORDION ---
      if (addonsAcc) {
        const list = selectedAddOnsList();
        const visible = list.length > 0;

        let price = 0;
        let itemsHtml = '';

        if (visible) {
          price = sumAddOns();
          itemsHtml = list
            .map(it => `<li><span>${esc(it.qty)}x</span> <span>${esc(it.title)}</span></li>`)
            .join('');
          showEl(addonsAcc);
          const priceEl = addonsAcc.querySelector('.meal-builder-order__accordion-price');
          if (priceEl) priceEl.textContent = formatMoney(price, 'GBP');
          const itemsEl = addonsAcc.querySelector('.meal-builder-order__meal-items');
          if (itemsEl) itemsEl.innerHTML = itemsHtml;
        } else {
          hideEl(addonsAcc);
        }

        const newSig = [String(visible), price.toFixed(2), itemsHtml].join('|');
        pokeIfOpen(addonsAcc, newSig !== prevAddonsSig);
        prevAddonsSig = newSig;
      }

      // --- SUBTOTALS / TOTALS ---
      const base = getBasePrice();
      const addonsTotal = sumAddOns();
      const subtotal = base.amount + addonsTotal;
      const days = Math.max(1, toInt(MB?.state?.days, 5));
      const perDay = subtotal / days;

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal, base.currency);
      if (perDayEl) perDayEl.textContent = formatMoney(perDay, base.currency);
      if (totalFirstEl) totalFirstEl.textContent = formatMoney(subtotal, base.currency);
      if (totalSubEl) totalSubEl.textContent = formatMoney(subtotal, base.currency);
    }

    // Listen ONLY to authoritative events:
    // - mealbuilder:data fires after Save in the grouping popup (your code already does this)
    // - mealbuilder:addons-changed fires when add-ons quantities change
    const section = document.getElementById(SECTION_ID);
    if (section) {
      section.addEventListener('mealbuilder:data', () => render());
      section.addEventListener('mealbuilder:addons-changed', () => render());
    }

    // Initial paint
    render();

    MB._orderAccordionWired = true;
  }

  // =========================
  // Discounts (Intro + Manual codes with structured conditions) — refined
  // =========================
  function installDiscountsHandler() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._discountsWired) return;
    MB._discountsWired = true;

    // ---------- DOM roots ----------
    const orderRoot = document.getElementById('meal-builder-order'); // holds data-* conditions
    const summaryRoot = document.querySelector('[data-show-order-summary]'); // container with code input area

    if (!orderRoot || !summaryRoot) return;

    // ---------- summary controls / pills ----------
    const inputEl = summaryRoot.querySelector('.meal-builder-order__discount-input');
    const applyBtn = summaryRoot.querySelector('.meal-builder-order__discount-apply');
    const activeWrap = summaryRoot.querySelector('.meal-builder-order__active-code');
    const activeText = summaryRoot.querySelector('.meal-builder-order__active-code-text');
    const activeValue = summaryRoot.querySelector('.meal-builder-order__active-code-value');
    const removeBtn = summaryRoot.querySelector('.meal-builder-order__active-code-remove');

    if (activeWrap) activeWrap.classList.add('hidden');

    // Entire discount input block (will be hidden when manual codes are empty/invalid)
    const discountBlock = summaryRoot.querySelector('.meal-builder-order__discount');

    // ---------- offer / totals UI ----------
    const offerWrap = document.querySelector('.meal-builder-order__offer');
    const offerTextEl = document.querySelector('.meal-builder-order__offer-text');
    const offerValueEl = document.querySelector('.meal-builder-order__offer-value');
    const subDiscValue = document.querySelector('.meal-builder-order__subtotal-discount-value');
    const totalsRoot = document.querySelector('.meal-builder-order__total');

    // ---------- Shopify endpoints ----------
    const CART_UPDATE_URL = window.theme?.routes?.cart_update_url || '/cart/update';

    // ---------- formatting ----------
    const moneySymbol = code =>
      ({ GBP: '£', USD: '$', EUR: '€' })[(code || 'GBP').toUpperCase()] || '';
    const formatMoney = (amount, currency = 'GBP') =>
      `${moneySymbol(currency)}${(Number(amount) || 0).toFixed(2)}`;
    const formatMoneyCents = (cents, currency = 'GBP') =>
      formatMoney((Number(cents) || 0) / 100, currency);

    // ---------- numerics ----------
    const toInt = (v, d = 0) => {
      if (v === 0) return 0;
      const n = Number.parseInt(v, 10);
      return Number.isNaN(n) ? d : n;
    };
    const toNum = (v, d = 0) => {
      if (v === 0) return 0;
      const n = Number(v);
      return Number.isNaN(n) ? d : n;
    };

    // ---------- price helpers ----------
    function getBundleVariantForDays(days) {
      const bp = window.PRESS_MEAL_PLAN?.bundleProduct;
      if (!bp) return null;
      const mappedId = bp.dayVariantMap?.[days];
      let v = mappedId ? (bp.variants || []).find(x => String(x.id) === String(mappedId)) : null;
      if (!v) v = (bp.variants || [])[0] || null;
      return v;
    }

    function getBasePrice() {
      const days = toInt(window.MealBuilder?.state?.days, 5);
      const v = getBundleVariantForDays(days);
      return {
        amount: Number(v?.price?.amount || 0),
        currency: v?.price?.currencyCode || 'GBP'
      };
    }

    function sumAddOns() {
      const host = document.querySelector('.meal-builder-main__add-ons-section');
      if (!host) return 0;
      let total = 0;
      host
        .querySelectorAll('.meal-builder-main-product-card.meal-builder-main-product-card--add-on')
        .forEach(card => {
          const qty = toInt(
            card.querySelector('.meal-builder-main-product-card__quantity-input')?.value,
            0
          );
          if (qty <= 0) return;
          const unit = toNum(card.dataset.unitPrice, 0) || 0;
          total += qty * unit;
        });
      return total;
    }

    function currentWeekBaseSubtotal() {
      const base = getBasePrice();
      const addons = sumAddOns();
      return { subtotal: base.amount + addons, currency: base.currency };
    }

    // ---------- conditions parsing ----------
    function parseConditionsValue(str) {
      if (!str || typeof str !== 'string') return null;
      const parts = str
        .split('||')
        .map(s => s.trim())
        .filter(s => s !== '');

      // if (parts.length !== 4) return null;

      const p1 = toInt(parts[0], -1);
      const w1 = toInt(parts[1], -1);
      const p2 = toInt(parts[2], -1);
      const w2 = toInt(parts[3], -1);
      // if ([p1, w1, p2, w2].some(n => n < 0)) return null;

      const steps = [];
      if (p1 > 0) steps.push({ percent: p1, weeks: w1 }); // weeks=0 => infinite
      if (p2 > 0) steps.push({ percent: p2, weeks: w2 });

      return { p1, w1, p2, w2, steps };
    }

    function parseManualCodesMap(raw) {
      // Accepts "<CODE> || p1 || w1 || p2 || w2" per line, separated by <br /> or new lines
      if (!raw || typeof raw !== 'string') return {};
      const lines = raw
        .split(/<br\s*\/?>|\n/gi)
        .map(s => s.trim())
        .filter(Boolean);
      const out = {};
      for (const line of lines) {
        const parts = line.split('||').map(s => s.trim());
        if (parts.length !== 5) continue;
        const [code, ...cond] = parts;
        const parsed = parseConditionsValue(cond.join(' || '));
        if (code && parsed) {
          out[code.toLowerCase()] = { code, ...parsed };
        }
      }
      return out;
    }

    // single auto-apply parser "CODE || p1 || w1 || p2 || w2"
    function parseSingleAutoCond(str) {
      if (!str || typeof str !== 'string') return null;
      const parts = str
        .split('||')
        .map(s => s.trim())
        .filter(Boolean);
      if (parts.length !== 5) return null;
      const [code, ...condParts] = parts;
      if (!code) return null;
      const cond = parseConditionsValue(condParts.join(' || '));
      if (!cond) return null;
      return { code, cond };
    }

    // ---------- copy helpers ----------
    const plural = (n, one, many) => (n === 1 ? one : many);

    // Build visible lines for the offer block.
    // isIntro=true  => "New Customer Offer:"
    // isIntro=false => "<CODE> Offer:"
    function buildOfferLines(cond, isIntro, codeLabel) {
      const { p1, w1, p2, w2 } = cond;
      const lines = [];
      // Prefer showing the explicit code when provided
      const head = codeLabel ? `${codeLabel} Offer:` : isIntro ? 'New Customer Offer:' : 'Offer:';
      lines.push(head);

      // First step
      if (p1 > 0) {
        if (w1 === 0) {
          lines.push(`${p1}% off your initial order and all subsequent weeks`);
          return lines; // second step is irrelevant if first is infinite
        } else if (w1 === 1) {
          lines.push(`${p1}% off your first week`);
        } else {
          lines.push(`${p1}% off your first ${w1} ${plural(w1, 'week', 'weeks')}`);
        }
      }

      // Second step
      if (p2 > 0) {
        if (w2 === 0) {
          lines.push(`${p2}% off all subsequent weeks`);
        } else {
          lines.push(`${p2}% off next ${w2} ${plural(w2, 'week', 'weeks')}`);
        }
      }

      // "Full price" line if everything finite or no discounts at all
      const firstFinite = p1 <= 0 ? true : w1 !== 0;
      const secondFinite = p2 <= 0 ? true : w2 !== 0;
      const noDiscounts = p1 <= 0 && p2 <= 0;

      if (
        noDiscounts ||
        (firstFinite && p1 > 0 && p2 <= 0) ||
        (firstFinite && secondFinite && p1 > 0 && p2 > 0) ||
        (p1 <= 0 && p2 > 0 && w2 > 0)
      ) {
        lines.push('Full price for all subsequent weeks');
      }

      return lines;
    }

    // ---------- totals rendering ----------
    const discountedPrice = (base, percent) => {
      const pct = Math.max(0, Number(percent) || 0);
      return base * (1 - pct / 100);
    };

    function renderTotals(cond, baseSubtotal, currency) {
      if (!totalsRoot) return;

      const rows = [];
      const { p1, w1, p2, w2 } = cond;

      const priceFull = baseSubtotal;
      const priceP1 = discountedPrice(baseSubtotal, p1);
      const priceP2 = discountedPrice(baseSubtotal, p2);

      function pushRow(label, price, cls) {
        rows.push(`<div class="meal-builder-order__row">
        <span class="${/first/i.test(label) ? 'meal-builder-order__total-first' : 'meal-builder-order__total-sub'}">${label}</span>
        <span class="${cls}">${formatMoney(price, currency)}</span>
      </div>`);
      }

      const planWeeklyCostEl = document.querySelector('.meal-builder-order__plan-weekly-cost');
      const weeklyCost = getBasePrice().amount;
      const weeklyDiscountedCost = discountedPrice(weeklyCost, p1);
      if (planWeeklyCostEl)
        planWeeklyCostEl.textContent = formatMoney(weeklyDiscountedCost, currency);

      const planTotalCostEl = document.querySelector('.meal-builder-order__plan-total-cost');
      if (planTotalCostEl) planTotalCostEl.textContent = formatMoney(priceP1, currency);

      if (p1 > 0) {
        if (w1 === 0) {
          pushRow('First week total', priceP1, 'meal-builder-order__total-first-price');
          pushRow('Subsequent Weeks Total', priceP1, 'meal-builder-order__total-sub-price');
        } else if (w1 === 1) {
          pushRow('First week total', priceP1, 'meal-builder-order__total-first-price');
          if (p2 > 0) {
            if (w2 === 0) {
              pushRow('Subsequent Weeks Total', priceP2, 'meal-builder-order__total-sub-price');
            } else {
              pushRow(
                `Next ${w2} ${plural(w2, 'Week', 'Weeks')} Total`,
                priceP2,
                'meal-builder-order__total-sub-price'
              );
              pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
            }
          } else {
            pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
          }
        } else {
          pushRow(
            `First ${w1} ${plural(w1, 'Week', 'Weeks')} Total`,
            priceP1,
            'meal-builder-order__total-first-price'
          );
          if (p2 > 0) {
            if (w2 === 0) {
              pushRow('Subsequent Weeks Total', priceP2, 'meal-builder-order__total-sub-price');
            } else {
              pushRow(
                `Next ${w2} ${plural(w2, 'Week', 'Weeks')} Total`,
                priceP2,
                'meal-builder-order__total-sub-price'
              );
              pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
            }
          } else {
            pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
          }
        }
      } else if (p2 > 0) {
        if (w2 === 0) {
          pushRow('First week total', priceP2, 'meal-builder-order__total-first-price');
          pushRow('Subsequent Weeks Total', priceP2, 'meal-builder-order__total-sub-price');
        } else {
          pushRow(
            `First ${w2} ${plural(w2, 'Week', 'Weeks')} Total`,
            priceP2,
            'meal-builder-order__total-first-price'
          );
          pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
        }
      } else {
        pushRow('First week total', priceFull, 'meal-builder-order__total-first-price');
        pushRow('Subsequent Weeks Total', priceFull, 'meal-builder-order__total-sub-price');
      }

      rows.push(`<div class="meal-builder-order__row">
        <span class="meal-builder-order__total-delivery">Delivery <span>(FREE for orders over £50)</span></span>
        <span class="meal-builder-order__total-delivery meal-builder-order__total-delivery-price">${priceP1 > 50 ? 'FREE' : formatMoney(6.95, currency)}</span>
      </div>`);

      totalsRoot.innerHTML = rows.join('');
    }

    // ---------- offer UI ----------
    function setOfferVisible(visible) {
      if (!offerWrap) return;
      offerWrap.style.display = visible ? '' : 'none';
    }

    function renderOfferUI(cond, isIntro, codeLabel) {
      const { subtotal, currency } = currentWeekBaseSubtotal();
      if (!cond) {
        setOfferVisible(false);
        return;
      }

      // If both discounts are 0% — hide offer (there is nothing to advertise)
      if (cond.p1 <= 0 && cond.p2 <= 0) {
        setOfferVisible(false);
        renderTotals(cond, subtotal, currency); // still render plain totals
        if (offerValueEl) offerValueEl.textContent = `-${formatMoney(0, currency)}`;
        if (subDiscValue) subDiscValue.textContent = `${formatMoney(0, currency)}`;
        return;
      }

      // 1) Offer heading + lines
      const lines = buildOfferLines(cond, isIntro, codeLabel);
      if (!lines.length) {
        setOfferVisible(false);
        return;
      }
      if (offerTextEl) {
        // offerTextEl.innerHTML = [lines[0], ...lines.slice(1).map(l => `<br>${l}`)].join(' ');
        offerTextEl.innerHTML = `<strong>${lines[0]}</strong><br>${lines.slice(1).join('. ')}`;
      }

      // 2) Week-1 effective discount value shown as "-£X.XX" and "£X.XX"
      const effPctWeek1 = cond.p1 > 0 ? cond.p1 : cond.p2 > 0 ? cond.p2 : 0;
      const discountAmount = subtotal - discountedPrice(subtotal, effPctWeek1);
      if (offerValueEl) offerValueEl.textContent = `-${formatMoney(discountAmount, currency)}`;
      if (subDiscValue) subDiscValue.textContent = `${formatMoney(discountAmount, currency)}`;

      // 3) Totals block
      renderTotals(cond, subtotal, currency);

      // 4) Active pill: show only for manual codes (we treat auto as "intro-like")
      const showPill = !!codeLabel;
      if (activeWrap)
        showPill ? activeWrap.classList.remove('hidden') : activeWrap.classList.add('hidden');
      if (showPill) {
        if (activeText) activeText.textContent = codeLabel;
        if (activeValue) activeValue.textContent = `-${formatMoney(discountAmount, currency)}`;
      }

      setOfferVisible(true);
    }

    // ---------- state ----------
    MB._activeDiscountScenario = null; // { source:'intro'|'manual', code?:string, cond:{p1,w1,p2,w2,steps:[]} }

    function readScenariosFromDOM() {
      const introRaw = orderRoot?.dataset?.introOfferDiscountConditions || '';
      const manualRaw = orderRoot?.dataset?.othersManualDiscountsConditions || '';
      const autoRaw = orderRoot?.dataset?.autoApplyDiscountConditions || '';

      const introCond = parseConditionsValue(introRaw);
      const manualMap = parseManualCodesMap(manualRaw);
      const autoEntry = parseSingleAutoCond(autoRaw);

      return { introCond, manualMap, manualRaw, autoEntry };
    }

    const { introCond, manualMap, manualRaw, autoEntry } = readScenariosFromDOM();
    MB._manualCodesMap = manualMap;

    const hasAnyManual = manualRaw.trim().length > 0 && Object.keys(manualMap).length > 0;
    if (discountBlock) discountBlock.style.display = hasAnyManual ? '' : 'none';

    if (autoEntry) {
      MB._activeDiscountScenario = { source: 'auto', code: autoEntry.code, cond: autoEntry.cond };
    } else if (introCond) {
      MB._activeDiscountScenario = { source: 'intro', cond: introCond };
    } else {
      setOfferVisible(false);
    }

    // Initial paint (single call)
    if (MB._activeDiscountScenario?.cond) {
      const { source, code, cond } = MB._activeDiscountScenario;
      const isIntroLike = source !== 'manual'; // intro & auto
      const codeLabel = source === 'manual' || source === 'auto' ? code : '';
      renderOfferUI(cond, isIntroLike, codeLabel);
    } else {
      const { subtotal, currency } = currentWeekBaseSubtotal();
      renderTotals({ p1: 0, w1: 0, p2: 0, w2: 0, steps: [] }, subtotal, currency);
    }

    // ---------- apply/remove manual codes ----------
    async function updateCartDiscountCsv(csv) {
      // Best effort: keep cart and checkout in sync with chosen code.
      try {
        const res = await fetch(CART_UPDATE_URL, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: csv })
        });
        return res.ok;
      } catch {
        return false;
      }
    }

    // expose helper to apply auto code after cart add
    MB.Discounts = MB.Discounts || {};
    MB.Discounts.applyAutoCodeIfAny = async function () {
      const sc = MB._activeDiscountScenario;
      if (sc?.source === 'auto' && sc?.code) {
        try {
          const ok = await updateCartDiscountCsv(sc.code); // POST /cart/update
          return !!ok;
        } catch {
          return false;
        }
      }
      return false;
    };

    async function onApplyClick(e) {
      e?.preventDefault?.();
      if (!inputEl || !applyBtn) return;

      const raw = (inputEl.value || '').trim();
      if (!raw) return;

      const key = raw.toLowerCase();
      const entry = MB._manualCodesMap?.[key];

      if (!entry) {
        alert('This discount code does not apply to this Meal Plan.');
        return;
      }

      applyBtn.disabled = true;
      try {
        await updateCartDiscountCsv(entry.code); // ignore result, keep UI consistent regardless
        MB._activeDiscountScenario = {
          source: 'manual',
          code: entry.code,
          cond: { p1: entry.p1, w1: entry.w1, p2: entry.p2, w2: entry.w2, steps: entry.steps }
        };
        inputEl.value = '';
        renderOfferUI(MB._activeDiscountScenario.cond, false, entry.code);
      } catch (err) {
        console.warn('[MealBuilder] apply code failed', err);
        alert('Could not apply the code. Try again.');
      } finally {
        applyBtn.disabled = false;
      }
    }

    async function onRemoveClick(e) {
      e?.preventDefault?.();

      try {
        await updateCartDiscountCsv('');
      } catch {}

      if (introCond) {
        MB._activeDiscountScenario = { source: 'intro', cond: introCond, code: '' };
        renderOfferUI(MB._activeDiscountScenario.cond, true, '');
        if (activeWrap) activeWrap.classList.add('hidden');
      } else {
        MB._activeDiscountScenario = null;
        setOfferVisible(false);
        if (activeWrap) activeWrap.classList.add('hidden');

        const { subtotal, currency } = currentWeekBaseSubtotal();
        renderTotals({ p1: 0, w1: 0, p2: 0, w2: 0, steps: [] }, subtotal, currency);

        if (offerValueEl) offerValueEl.textContent = `-${formatMoney(0, currency)}`;
        if (subDiscValue) subDiscValue.textContent = `${formatMoney(0, currency)}`;
      }
    }

    applyBtn?.addEventListener('click', onApplyClick);
    inputEl?.addEventListener('keydown', ev => {
      if (ev.key === 'Enter') onApplyClick(ev);
    });
    removeBtn?.addEventListener('click', onRemoveClick);

    // ---------- reactive recompute (on plan changes / add-ons changes) ----------
    function rerenderOnChange() {
      if (MB._activeDiscountScenario?.cond) {
        const { source, code, cond } = MB._activeDiscountScenario;
        const isIntroLike = source !== 'manual';
        const codeLabel = source === 'manual' || source === 'auto' ? code : '';
        renderOfferUI(cond, isIntroLike, codeLabel);
      } else {
        const { subtotal, currency } = currentWeekBaseSubtotal();
        renderTotals({ p1: 0, w1: 0, p2: 0, w2: 0, steps: [] }, subtotal, currency);
      }
    }

    const section = document.getElementById('customMealBuilderLeadingSection');
    section?.addEventListener('mealbuilder:data', rerenderOnChange);
    section?.addEventListener('mealbuilder:addons-changed', rerenderOnChange);

    // Final guard paint
    rerenderOnChange();
  }

  // =========================
  // Intro-login reminder (toast)
  // =========================
  function installIntroLoginNotice() {
    const MB = (window.MealBuilder = window.MealBuilder || {});
    if (MB._introNoticeWired) return;
    MB._introNoticeWired = true;

    function isCustomerLoggedIn() {
      try {
        if (typeof window.__MB_CUSTOMER_LOGGED_IN__ !== 'undefined')
          return !!window.__MB_CUSTOMER_LOGGED_IN__;
        if (document.documentElement?.dataset?.customerLoggedIn)
          return document.documentElement.dataset.customerLoggedIn === 'true';
        if (document.body?.classList?.contains('customer-logged-in')) return true;
        if (
          window.Shopify?.customer &&
          (window.Shopify.customer.id || window.Shopify.customer.email)
        )
          return true;
      } catch (_) {}
      return false;
    }

    let el = null;
    let tmr = null;

    function ensureEl() {
      if (el) return el;
      el = document.createElement('div');
      el.className = 'mb-intro-login-notice';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
      el.innerHTML =
        'Note: you must be logged in to see the <strong>New Customer Discount</strong>';
      el.addEventListener('click', hide, { capture: true });
      document.body.appendChild(el);
      return el;
    }

    function show(durationMs = 5000) {
      const n = ensureEl();
      // re-show every time: clear old timer and (re)apply visible class
      clearTimeout(tmr);
      n.classList.add('mb-intro-login-notice--visible');
      tmr = setTimeout(hide, durationMs);
    }

    function hide() {
      if (!el) return;
      el.classList.remove('mb-intro-login-notice--visible');
    }

    let errorEl = null;
    let errorTmr = null;

    function ensureErrorEl() {
      if (errorEl) return errorEl;
      errorEl = document.createElement('div');
      errorEl.className = 'mb-intro-login-notice mb-intro-login-notice--error';
      errorEl.setAttribute('role', 'alert');
      errorEl.setAttribute('aria-live', 'assertive');
      errorEl.innerHTML =
        'There was an error adding your Meal Plan to the cart. Please try again. If it continues to fail, please reach out to customer services';
      errorEl.addEventListener('click', hideError, { capture: true });
      document.body.appendChild(errorEl);
      return errorEl;
    }

    function showError(durationMs = 5000) {
      const n = ensureErrorEl();
      clearTimeout(errorTmr);
      n.classList.add('mb-intro-login-notice--visible');
      errorTmr = setTimeout(hideError, durationMs);
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.classList.remove('mb-intro-login-notice--visible');
    }

    // Public API: call right after cart add finishes
    MB.Notice = MB.Notice || {};
    MB.Notice.maybeShowIntroLoginReminder = function () {
      const isIntro = MB._activeDiscountScenario?.source === 'intro';
      if (!isIntro) return;
      if (isCustomerLoggedIn()) return;
      show(5000);
    };

    MB.Notice.showPresetError = function () {
      showError(5000);
    };
  }

  // =========================
  // Bootstrap flow
  // =========================
  async function main() {
    const section = document.getElementById(SECTION_ID);
    if (!section) {
      warn('[MealBuilder] Section #' + SECTION_ID + ' not found');
      return;
    }

    // Start data building ASAP; keep a promise to await in controls
    const dataReadyPromise = buildPressMealPlan();

    // Install modules
    installFilteringModule();
    installControls(dataReadyPromise);
    installRenderer();
    installAddOnsSection(dataReadyPromise);
    installCaloriesCounter();
    installBundlePayloadBuilder();
    installGroupingPopupBinder();
    installProductPopupBinder();
    installRechargeCartHandler_NoProductForm();
    installOrderAccordion();
    installDiscountsHandler();
    installIntroLoginNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main, { once: true });
  } else {
    main();
  }
})();

// =================
// SHOW/HIDDEN POPUP
// =================
const POPUP_GROUPING = document.querySelector('[data-custom-meal-builder-popup-grouping]');
const POPUP_GROUPING_CLOSE_MODAL = document.querySelector(
  '[data-custom-meal-builder-popup-grouping-close-modal]'
);
const POPUP_PRODUCT = document.querySelector('[data-custom-meal-builder-popup-product-card]');

let isGroupingOpen = false;
let isProductOpen = false;

function customMealShowPopup(type) {
  document.body.style.overflow = 'hidden';

  if (type === 'grouping') {
    POPUP_GROUPING.style.opacity = '1';
    POPUP_GROUPING.style.visibility = 'visible';
    POPUP_GROUPING.style.pointerEvents = 'auto';
    isGroupingOpen = true;
  } else if (type === 'cancel') {
    POPUP_GROUPING_CLOSE_MODAL.style.opacity = '1';
    POPUP_GROUPING_CLOSE_MODAL.style.visibility = 'visible';
    POPUP_GROUPING_CLOSE_MODAL.style.pointerEvents = 'auto';
  } else {
    POPUP_PRODUCT.style.opacity = '1';
    POPUP_PRODUCT.style.visibility = 'visible';
    POPUP_PRODUCT.style.pointerEvents = 'auto';
    isProductOpen = true;
  }
}

function customMealCancelPopup(event, type) {
  const isCloseIntent =
    event.target === event.currentTarget ||
    event.target.classList.contains('meal-builder-main-grouping-popup__header-close');

  if (!isCloseIntent) return;

  // If current grouping popup has unsaved changes → show confirm modal
  const popup = document.querySelector('[data-custom-meal-builder-popup-grouping]');
  const hasUnsavedChanges = !!(popup && popup._mbDirty);

  if (hasUnsavedChanges) {
    customMealShowPopup('cancel');
  } else {
    closeCustomMealPopup();
  }
}

function customMealHiddenPopup(event) {
  if (event.target === event.currentTarget) closeCustomMealPopup();
}

function closeCustomMealPopup(type) {
  if (type === 'no') {
    hidePopup(POPUP_GROUPING_CLOSE_MODAL);
    return;
  }

  if (isGroupingOpen && isProductOpen) {
    hidePopup(POPUP_PRODUCT);
    isProductOpen = false;
    return;
  }

  hidePopup(POPUP_PRODUCT);
  hidePopup(POPUP_GROUPING);
  hidePopup(POPUP_GROUPING_CLOSE_MODAL);
  isGroupingOpen = false;
  isProductOpen = false;

  setTimeout(() => (document.body.style.overflow = ''), 150);
}

function hidePopup(el) {
  el.style.opacity = '0';
  el.style.visibility = 'hidden';
  el.style.pointerEvents = 'none';
}

let isOpenOrderSummary = false;

function toggleOrderSummary() {
  const orderSummaryWrapper = document.querySelector('[data-show-order-summary]');
  const orderSummaryOverlay = document.querySelector('.meal-builder-order__open-order-overlay');
  const mainContentBuilder = document.querySelector('.custom-meal-builder-leading-section');

  if (!isOpenOrderSummary) {
    if (mainContentBuilder) {
      const rect = mainContentBuilder.getBoundingClientRect();
      const sectionBottom = rect.bottom + window.scrollY;
      const viewportBottom = window.scrollY + window.innerHeight;

      if (viewportBottom > sectionBottom) {
        window.scrollTo({
          top: sectionBottom - window.innerHeight,
          behavior: 'smooth'
        });
      }
    }

    document.body.style.overflow = 'hidden';
    orderSummaryOverlay.style.opacity = '1';
    orderSummaryOverlay.style.visibility = 'visible';
    orderSummaryOverlay.style.pointerEvents = 'auto';
    orderSummaryWrapper.classList.add('active');
    isOpenOrderSummary = true;
  } else {
    orderSummaryOverlay.style.opacity = '0';
    orderSummaryOverlay.style.visibility = 'hidden';
    orderSummaryOverlay.style.pointerEvents = 'none';
    orderSummaryWrapper.classList.remove('active');
    isOpenOrderSummary = false;

    setTimeout(() => (document.body.style.overflow = ''), 150);
  }
}

// =====================
// SHOW/HIDDEN ACCORDION
// =====================
class MealAccordion extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-accordion-toggle]');
    const content = this.querySelector('[data-accordion-content]');
    const icon = this.querySelector('[data-accordion-icon]');

    if (!button || !content) return;

    button.addEventListener('click', () => {
      const isOpen = this.classList.toggle('is-open');
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
      button.setAttribute('aria-expanded', isOpen);
      if (icon) icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    });
  }
}

customElements.define('meal-accordion', MealAccordion);
